$(function () {

    widget = {
        parse: function () {
            var self = this;
            var newElements = $("[widget]:not([widgetId])");
            $.each(newElements, function (index, node) {
                self.require($(node).attr('widget'), node);
            });
        },
        getById: function (id) {
            if (typeof id === 'undefined') {
                console.log('Couldn\'t get widget, got no id');
                return;
            }
            var widget = $('[widgetid="' + id + '"]');
            if (widget.length === 0) {
                console.log('Couldn\'t get widget with id ' + id);
                // Workaround: remove the dialog slider to make the system useable again.
                var backdrop = $('.modal-backdrop');
                if (backdrop.length === 1) {
                    backdrop.remove();
                    $('.dialog.modal.fade.in').remove();
                    var notifier = Esearcher.Ui.Notifier.getInstance();
                    var errorText = 'Es ist ein Problem aufgetreten, bitte versuchen Sie es erneut.';
                    notifier.notify(errorText, Esearcher.Ui.Notifier.TYPE_ERROR);
                }
                return;
            }
            var widgetClassName = widget.attr('widget');
            var str = widgetClassName.split('.');
            var jqueryConformClassName = str[0];
            var version = parseInt($.ui.version.split('.').join(''));
            if (version > 190) {
                jqueryConformClassName += '-' + str[1];
            }
            else {
                jqueryConformClassName += str[0].substring(0, 1).toUpperCase() + str[0].substring(1, str[0].Length);
            }
            var object = widget.data(jqueryConformClassName);
            return object;
        },
        _createWidget: function (widgetName, node) {
            $(node)[widgetName]();
        },
        require: function (name, node, asyncCallbackFnc, asyncCallbackArgs) {
            if (name.length === 0) {
                return;
            }
            var jsFile = '/scripts/' + name.replace(/\.|_/ig, '/') + '.js?_d=' + $('body').data('es3VersionHash');
            var widgetName = name.replace(/\.|_/ig, '_');
            var widgetNameSpace = name.split('.');
            if (typeof $.esearcher !== 'undefined' && typeof $.esearcher[widgetNameSpace[1]] !== 'undefined') {
                if (typeof node != 'undefined' && typeof $(node)[widgetName] == 'undefined') {
                    this._loadWidget(name, jsFile, node, widgetName, asyncCallbackFnc, asyncCallbackArgs);
                    return;
                }
                if (typeof node != 'undefined') {
                    this._createWidget(widgetName, node);
                }
                return;
            }
            this._loadWidget(name, jsFile, node, widgetName, asyncCallbackFnc, asyncCallbackArgs);
        },
        _loadWidget: function (name, jsFile, node, widgetName, asyncCallbackFnc, asyncCallbackArgs) {
            var self = this;
            $.ajaxSetup({async: false, cache: true});
            $.getScript(jsFile).done(function (data, textStatus, jqxhr) {
                $.ajaxSetup({async: true, cache: false});
                var classNames = name.split('.');
                if (typeof node != 'undefined') {

                    var object = $[classNames[0]];
                    for (var p = 1, length = classNames.length; p < length; p++) {
                        if (typeof object[classNames[p]] === 'undefined') {
                            console.error('Widget not found: ' + classNames[p]);
                            throw 'error';
                        }
                        object = object[classNames[p]];
                    }

                    $.widget.bridge(widgetName, object);
                    self._createWidget(widgetName, node);
                }
                if (typeof asyncCallbackFnc === 'function') {
                    asyncCallbackFnc(asyncCallbackArgs);
                }
            }).fail(function (jqxhr, settings, exception) {
                console.error('Widget load error! Couldn\'t load file ' + jsFile + ' .');
                console.error(name.length);
                console.error(exception);
                console.error(jqxhr);
                throw 'error';
            });
        }
    };

    widget.parse();

    $(document).on('loadFinish', function () {
        widget.parse();
    });
});

$(function () {
    var isInIframe = (window.location != window.parent.location) ? true : false;
    if (isInIframe) {
        return;
    }
    if (Cookies.get('__messages') !== undefined) {
        var e = Cookies.getJSON('__messages');
        Cookies.remove('__messages');
        var notifier = Esearcher.Ui.Notifier.getInstance();
        $.each(e, function (part, data) {
            $.each(data, function (a, text) {
                notifier.notify(text.replace(/&nbsp;/g, ' '), part);
            });
        });
    }
    var polling = new Esearcher.Polling(
        'reminderService-getCurrentReminders',
        60000,
        function (data) {
            for (var index = 0; index < data.length; ++index) {
                if (!($('#reminder_' + data[index].id).length)) {
                    new PNotify({
                        id: '#reminder_'+data[index].id,
                        title: data[index].title,
                        text: data[index].html,
                        hide: false,
                        buttons: {
                            closer: false,
                            sticker: false
                        }
                    });
                }

            }
            bindDeactiveReminderEvent();
            bindDelay60ReminderEvent();
            bindSelectDelayEvent();
        },
        true
    );
    var connect = Esearcher.Connect.getInstance();
    connect.poll(polling);

    function bindDeactiveReminderEvent() {
        $(document).off('click', '[name=deactivate]');
        $(document).on('click', '[name=deactivate]', function (e) {
            var id = $(e.target).attr('data-id');
            $.ajax({
                url: '/reminder/disable/'+id,
                method: 'POST',
            }).done(function() {
                for (var i = 0; i < PNotify.notices.length; i++) {
                    if (PNotify.notices[i].options.id == "#reminder_"+id) {
                        PNotify.notices[i].remove();
                    }
                }
                connect.runPolling('reminderService-getCurrentReminders');
            });
        });
    }

    function bindDelay60ReminderEvent() {
        $(document).off('click', '[name=delay60]');
        $(document).on('click', '[name=delay60]', function (e) {
           var id = $(e.target).attr('data-id');
           $.ajax({
               url: '/reminder/delay/60/'+id,
               method: 'POST'
           }).done(function() {
               for (var i = 0; i < PNotify.notices.length; i++) {
                    if (PNotify.notices[i].options.id == "#reminder_"+id) {
                        PNotify.notices[i].remove();
                    }
                }
               connect.runPolling('reminderService-getCurrentReminders');
           });
        });
    }

    function bindSelectDelayEvent() {
        $(document).on('click', '[name=selectDelay]', function (e) {
            var parentDiv = $(this).parents('div.ui-pnotify');
            $(document).find('div.ui-pnotify').css('z-index', 100040);
            parentDiv.css('z-index', 110040);

        });

        $(document).off('click', '[name=delay]');
        $(document).on('click', '[name=delay]', function (e) {
            var target = e;
            var delay = $(e.target).attr('data-id');
            var id = $(e.target).attr('id');
            $.ajax({
               url: '/reminder/delay/'+delay+'/'+id,
               method: 'POST'
            }).done(function() {
                for (var i = 0; i < PNotify.notices.length; i++) {
                    if (PNotify.notices[i].options.id == "#reminder_"+id) {
                        PNotify.notices[i].remove();
                    }
                }
                localStorage.removeItem("last-po-request-at");
				localStorage.removeItem("po-data-loaded-at");
            });
        });
    }
});
$(function () {
    $('select:not(.no-ready)').chosen({disable_search_threshold: 10});
});

(function ($) {
    $.detectSwipe = {
        version: '2.1.1',
        enabled: 'ontouchstart' in document.documentElement,
        preventDefault: true,
        threshold: 20
    };

    var startX,
            startY,
            isMoving = false;

    function onTouchEnd() {
        this.removeEventListener('touchmove', onTouchMove);
        this.removeEventListener('touchend', onTouchEnd);
        isMoving = false;
    }

    function onTouchMove(e) {
        if ($.detectSwipe.preventDefault) {
            e.preventDefault();
        }
        if (isMoving) {
            var x = e.touches[0].pageX;
            var y = e.touches[0].pageY;
            var dx = startX - x;
            var dy = startY - y;
            var dir;
            if (Math.abs(dx) >= $.detectSwipe.threshold) {
                dir = dx > 0 ? 'left' : 'right'
            }
            else if (Math.abs(dy) >= $.detectSwipe.threshold) {
                dir = dy > 0 ? 'down' : 'up'
            }
            if (dir) {
                onTouchEnd.call(this);
                $(this).trigger('swipe', dir).trigger('swipe' + dir);
            }
        }
    }

    function onTouchStart(e) {
        if (e.touches.length == 1) {
            startX = e.touches[0].pageX;
            startY = e.touches[0].pageY;
            isMoving = true;
            this.addEventListener('touchmove', onTouchMove, false);
            this.addEventListener('touchend', onTouchEnd, false);
        }
    }

    function setup() {
        this.addEventListener && this.addEventListener('touchstart', onTouchStart, false);
    }

    function teardown() {
        this.removeEventListener('touchstart', onTouchStart);
    }

    $.event.special.swipe = {setup: setup};

    $.each(['left', 'up', 'down', 'right'], function () {
        $.event.special['swipe' + this] = {setup: function () {
                $(this).on('swipe', $.noop);
            }};
    });
})(jQuery);
/*global jQuery crm:true*/

var crm = (function() {
    var tab = [];
    var loader = '<span class="updateLoaderIcon"></span>';
    var getActiveTab = function() {
        return $('#tabs-right .ui-tabs-active a');
    };

    return {
        ajaxRequestUri: $('#tabs-right .ui-tabs-active a').data('route'),
        change_asp: 0,
        isCurrentlyLoading: false,

        placeLoadIndicator: function(tab) {
            $(tab).prepend(loader);
        },

        removeLoadIndicator: function(tab) {
            $(tab).find('#loadIndicator').remove();
        },

        showTabOverlay: function() {
            $('#tab-overlay').height($('#tabs-right').innerHeight());
        },

        hideTabOverlay: function() {
            $('#tab-overlay').height(0);
        },

        serializeForm: function() {

            var selector = '#tabs-right .ui-tabs-active a',
                formName  = $(selector).attr('href'),
                activeForm = $(formName+'Form');

            return activeForm.serialize();
        },

        getPanel: function(id) {
            return $('#' + id + '.ui-tabs-panel');
        },

        /**
         * Gibt die finale, fuer den AJAX-Request erforderliche URL zurueck
         *
         * @param {String|Number} dataId
         * @returns {String}
         */
        getFinalRequestUri: function(dataId) {
            var route = crm.ajaxRequestUri;
            return (route + (isNaN(dataId) || dataId === 0 ? '' : dataId) +
                    window.location.search);
        },

        /**
         * Gibt die Content-ID des aktiven Tabs zurueck.
         *
         * @returns {String}
         */
        getActiveTabContentId: function() {
            return getActiveTab().attr('href').replace('#', '');
        }
    };
}());

(function($) {
    'use strict';

    var init_tabs = (function() {

        var activeTab = null;
        var dataId = null;
        window.addEventListener('tab-change-element', function () {
            $('#saveBtn').show();
        });

        function showTabChangeConfirmationDialog(ui) {
            var showDialog = false;

            var formWidget = ui.oldPanel.find('form[widget="esearcher.form"]');
            if (formWidget.length != 0) {
                var dataSection = widget.getById(formWidget.attr('widgetid'));
                if (typeof dataSection != 'undefined' && dataSection.getStatus()) {
                    var tabClicked = ui.newTab.find('a');
                    var getText = $('#tab-overlay');
                    $('<div>').dialog({
                        title: getText.data('textDialogTitle'),
                        modal: true,
                        buttons: [{
                                text: getText.data('textDialogConfirm'),
                                position: '.modal-body',
                                click: function () {
                                    $('#saveBtn').click();
                                    $(this).dialog('destroy');
                                    $(document).bind('loadFinish.tabSaved', function () {
                                        dataSection.setStatus(false);
                                        tabClicked.click();
                                        $(document).unbind('loadFinish.tabSaved');
                                    });
                                }
                            },
                            {
                                text: getText.data('textDialogCancel'),
                                class: 'btn-negative',
                                position: '.modal-body',
                                click: function () {
                                    dataSection.setStatus(false);
                                    tabClicked.click();
                                    $(this).dialog('destroy');
                                }
                            }
                        ]
                    });
                    $('div.modal-dialog').addClass('modal-center-content');
                    showDialog = true;
                }
            }
            return showDialog;
        }

        /**
         * Erzeugt ein Objekt fuer Tab-Events.
         *
         * @param {String} tab Der Tab, fuer den das Event getriggert wird.
         * @param {Boolean} withPreventDefault Optionale Angabe (default false),
         *                                  ob eine preventDefault-Funktion
         *                                  integriert werden soll.
         * @returns {Object}
         */
        function makeEvent(tab, withPreventDefault) {
            var event = {
                tab: tab
            };

            if (withPreventDefault) {
                event._preventDefault = false;
                event.preventDefault = function () {
                    this._preventDefault = true;
                };
            }

            return event;
        }

        function loadContent(activeTab, panel, tabs) {
            crm.ajaxRequestUri = $(activeTab).find('a').data('route');

            if (activeTab) {

                var tabId = activeTab.find('a').attr('href').replace('#', '');
                $(panel).html('');

                crm.placeLoadIndicator(panel);

                var loader = new Esearcher.BlockLoader();

                loader.setAssetProcessing(true).mapBlocks({
                    'tabContent': $(panel)
                }).setCallback(function(){
                    $('.ui-tabs-panel.activeTab').removeClass('activeTab');
                    $(panel).addClass('activeTab');
                    crm.removeLoadIndicator(panel);

                    var tabFinishEvent = makeEvent(tabId, false);
                    Esearcher.trigger('tabFinish', tabFinishEvent);
                    tabs.tabs('enable'); // Debouncing the tabs (the tabs can now being clicked again)
                    saveButton(dataId, panel);
                }).request(crm.getFinalRequestUri(dataId));

                $(document).trigger('tabFinalRoute', crm.getFinalRequestUri(dataId));
           }
        }

        /**
         * core function -> ready =)
         * if there is a pagination, it will be reloaded
         */
        function saveTab(values, dataId, panel) {
            var tabId = panel.attr('id');

            crm.showTabOverlay(); // Puts the red overlay over the form

            $(document).one('loadFinish', function() {
                $('.updateLoader').remove();
                var saveFinishEvent = makeEvent(tabId, false);
                Esearcher.trigger('saveFinish', saveFinishEvent);
            });

            var loader = new Esearcher.BlockLoader();

            loader.mapBlocks({
                'tabContent': panel,
                'entityHeading': $('.entity-heading, title'),
                'classifications': $('.tags'),
                'customHeading': $('.custom-heading')
            }).setCallback(function () {
                crm.hideTabOverlay();
            }).request(crm.getFinalRequestUri(dataId), values, 'POST');
        }

        function saveButton(dataId, panel) {
            $(document)
                    .off('click', '#saveBtn')
                    .on('click', '#saveBtn', function() {

                        // Triggers all save events. If preventDefault is set, we can interrupt the normal save routine (e.g. useful on tabs with multiple forms)
                        // For an example see ext/system/JobExport/scripts/save.js
                        var tabId = panel.attr('id');
                        var saveEvent = makeEvent(tabId, true);
                        Esearcher.trigger('save', saveEvent);
                        if (saveEvent._preventDefault) {
                            return;
                        }

                        // Updates the textarea values with the content of the CkEditor fields.
                        $('textarea.ckEditor').each(function(idx, el) {
                            el = $(el);
                            var id   = el.attr('id'),
                                data = CKEDITOR.instances[id].getData();
                            el.text(data);
                        });

                        var values = crm.serializeForm();
                        if (values == '') {
                            // we have no data to store!
                            return;
                        }
                        saveTab(values, dataId, panel);
                    });
        }

        function getTabId (tab) {
            return $(tab).find('a').attr('href')
                .replace('#', '');
        }

        return {
            load: function () {
                var tabs = $("#tabs-right");
                dataId = parseInt($('#dataId').val(), 10);

                tabs.tabs({
                    beforeActivate: function( event, ui ) { // Is triggered after a tab switch
                        if (showTabChangeConfirmationDialog(ui)) { // If the dialog is shown we have to interrupt the normal tab change logic
                            return false;
                        }
                        var newTabId = getTabId(ui.newTab);
                        var oldTabId = getTabId(ui.oldTab);
                        var tabEvent = makeEvent(newTabId, true);

                        // Triggers all tab events. If preventDefault is set, we can interrupt the normal tab change event.
                        Esearcher.trigger('tab', tabEvent);
                        if (tabEvent._preventDefault) {
                            return false;
                        }

                        $(document).trigger('tabChange', {
                            newTab: newTabId,
                            oldTab: oldTabId
                        });

                        tabs.tabs('disable'); // Debouncing the tabs
                        ui.oldPanel.html(''); // Remove the HTML from the old panel before we load the new content

                        if (typeof event.currentTarget !== 'undefined') {
                            location.hash = event.currentTarget.hash; // Writes the hash of the tab to the url
                        } else {
                            location.hash = '#' + newTabId;
                        }

                        loadContent(ui.newTab, ui.newPanel, tabs);
                    },
                    create: function( event, ui ) { // Is triggered if the tab is initial opened or opened in a new browser tab or the page is reloaded
                        tabs.tabs('disable');
                        loadContent(ui.tab, ui.panel, tabs);
                    }
                });
            }
        };
    }(jQuery));

    $(function() {
        init_tabs.load();
        $('.ui-tabs-anchor').keydown(function () {
            return false;
        });
    });

}(jQuery));

// This variable is named with a capital letter, since it represents a namespace.
var Esearcher = namespace('Esearcher');

/**
 * Constructor for the Polling request
 *
 * @param {string} listener
 * @param {Number} timeout in milliseconds
 * @param {callback} callback
 * @param {boolean} active
 * @constructor
 */
Esearcher.Polling = function (listener, timeout, callback, active) {
    // the attributes are prefixed with 'polling' to assure their uniqueness,
    // since there are no private attributes in JS.
    this.pollingListener = listener;
    this.pollingTimeout = timeout;
    this.pollingCallback = callback;
    this.pollingActive = active;
};

Esearcher.Polling.prototype = {
    /**
     * Returns the listener.
     *
     * @return {string}
     */
    getListener: function () {
        return this.pollingListener;
    },

    /**
     * Returns the timeout.
     *
     * @return {Number}
     */
    getTimeout: function () {
        return this.pollingTimeout;
    },

    /**
     * Returns the callback function.
     *
     * @return {callback}
     */
    getCallback: function () {
        return this.pollingCallback;
    },

    /**
     * Tells if the polling request should be sent.
     *
     * @return {boolean}
     */
    isActive: function () {
        return this.pollingActive;
    },

    /**
     * Activates the polling
     *
     * @return {boolean}
     */
    activate: function () {
        this.pollingActive = true;
    },

    /**
     * Deactivates the polling.
     *
     * @return {boolean}
     */
    deactivate: function () {
        this.pollingActive = false;
    }
};

var ns = namespace('Esearcher');

ns.Connect = (function () {

    // Instance stores a reference to the Singleton
    var instance;

    function init() {
        return {
            xhr: null,
            listeners: {},
            status: false,
            poRequestTimeout: 6000, // Max time (in ms) that one PO Request should take
            /**
             * Send a call to the backend to receive new data
             *
             * @param {string} name
             * @param {object} data
             * @param {function} callback
             * @returns {void}
             */
            emit: function (name, data, callback) {
                var self = this;
                var callData = {};
                callData[name] = data;
                var transportData = {
                    caller: JSON.stringify(callData)
                };
                this.xhr = $.ajax({
                    url: "/po/" + this.uniqueUrlParam(),
                    method: "POST",
                    data: transportData,
                    success: function (data) {
                        if (typeof callback == 'function') {
                            callback(data.receiver[name]);
                        }
                        self._receive(data);
                        self.xhr = null;
                    },
                    complete: function () {
                        self.run();
                    }
                });
            },
            /**
             * Abort a pending xhr request from the connect request
             *
             * @returns {void}
             */
            abort: function () {
                // It needs to be checked with '!=' instead of '!==', otherwise it will not work properly
                if (typeof this.xhr !== 'undefined' && this.xhr != null) {
                    this.xhr.abort();
                }
                this.xhr = null;
            },
            /**
             * suspend a listener
             *
             * @param {string} name
             * @returns {boolean}
             */
            suspend: function (name) {
                var result = false;
                if (this.listeners.hasOwnProperty(name)) {
                    this.listeners[name].deactivate();
                    this._removeListenerItemsFromLocalStorage(name);
                    result = true;
                } else {
                    console.warn('Listener \'' + name + '\' not found!');
                }
                return result;
            },
            /**
             * Ree-enables a listener.
             *
             * @param {string} name
             * @return {boolean}
             */
            resume: function (name) {
                var result = false;
                if (this.listeners.hasOwnProperty(name)) {
                    this.listeners[name].activate();
                    result = true;
                } else {
                    console.warn('Listener \'' + name + '\' not found!');
                }
                return result;
            },
            /**
             * Re-enables a listener and executes it.
             *
             * @param {string} listener
             */
            resumeAndRunListener: function (listener) {
                if (this.resume(listener) === true) {
                    this.runPolling(listener);
                }
            },
            /**
             * Remove a listener from the stack
             *
             * @param {string} receiver
             * @returns {bool}
             */
            remove: function (receiver) {
                var status = false;
                if (typeof this.listeners[receiver] !== "undefined") {
                    this._removeListenerItemsFromLocalStorage(receiver);
                    delete this.listeners[receiver];
                    status = true;
                }
                return status;
            },
            /**
             * Return unique url parameter
             *
             * @returns {string}
             */
            uniqueUrlParam: function () {
                return md5(window.location.pathname);
            },
            /**
             * Decode response from server
             *
             * Call listeners who have been added
             * if data for this listeners arrives
             * @param {object} data
             * @returns {void}
             */
            _receive: function (data) {
                var self = this;
                if (typeof data.listeners === 'undefined') {
                    return;
                }
                $.each(data.listeners, function (listener, i) {
                    if (typeof self.listeners[listener] !== "undefined") {
                        var callbackFunction = self.listeners[listener].getCallback();
                        callbackFunction(data.listeners[listener]);
                    }
                });
            },
            /**
             * Trigger poll to refresh all active listeners with new data
             *
             * @returns {void}
             */
            refresh: function () {
                var self = this;
                if (this.xhr !== null) {
                    return;
                }
                var listeners = [];
                for (var listener in self.listeners) {
                    if (self.listeners.hasOwnProperty(listener) && self.listeners[listener].isActive()) {
                        listeners.push(listener);
                    }
                }
                this.xhr = $.ajax({
                    url: "/po/" + self.uniqueUrlParam(),
                    method: "POST",
                    data: {
                        listeners: listeners
                    },
                    success: function (data) {
                        self.xhr = null;
                        self._receive(data);
                    }});
            },
            /**
             * Polls a listener.
             * The listenerName must be registered in the listeners array.
             *
             * @param {Esearcher.Polling} polling
             */
            poll: function (polling) {
                var self = this;
                var listenerName = polling.getListener();

                if (this.status === false) {
                    window.onbeforeunload = function () {
                        self.abort();
                    };
                    this.status = true;
                }
                if (!this.listeners.hasOwnProperty(listenerName)) {
                    this.listeners[listenerName] = polling;
                }
                (function doPoll(listener) {
                    if (!self.listeners.hasOwnProperty(listener)) {
                        // The listener is not in the array anymore, so no more polling requests for this listener.
                        // It can be that a listener was removed from the array.
                        // Remove the entries from the localStorage from this listener.
                        self._removeListenerItemsFromLocalStorage(listener);
                        return;
                    }
                    var pollingRequest = self.listeners[listener];
                    var timeout = pollingRequest.getTimeout();

                    if (!pollingRequest.isActive()) {
                        // The PO request is not "killed" in order to allow its status to be set dynamically.
                        // Basically, the listener will not be triggered until the PO request is active.
                        window.setTimeout(doPoll, timeout, listener);
                        return;
                    }
                    // Checks if the data in the localStorage is still valid
                    var isDataValid = self._isDataValid(listener);
                    // Checks if should send a PO request, to update the localStorage
                    var shouldSendPO = self._shouldSendPO(listener);

                    // A PO request will only be sent, if the data in the localStorage for the current listener is no
                    // longer valid and if no PO request for the current listener was already sent by another
                    // browser tab.
                    // If the data in the localStorage is valid or a PO request for the current listener was already
                    // sent by another tab, the listener takes the data from the localStorage (also when the data in the
                    // localStorage hasn't been yet updated)
                    if (isDataValid || !shouldSendPO) {
                        var data = {};
                        data['listeners'] = self._readDataFromLocalStorage(listener);
                        self._receive(data);
                        window.setTimeout(doPoll, timeout, listener);
                    } else {
                        self.runPolling(listener).complete(function () {
                            window.setTimeout(doPoll, timeout, listener);
                            self.xhr = null;
                        });
                    }
                })(listenerName);
            },
            /**
             * Executes one polling request.
             *
             * @param {string} listener
             */
            runPolling: function (listener) {
                var lastPoRequestAtField = this._makeLocalStorageItemName(listener, 'last-po-request-at');

                localStorage.setItem(lastPoRequestAtField, (new Date()).getTime().toString());

                var self = this;
                this.xhr = $.ajax({
                    url: '/po/' + this.uniqueUrlParam(),
                    method: 'POST',
                    dataType: 'json',
                    timeout: this.poRequestTimeout,
                    data: {
                        listeners: [listener]
                    },
                    success: function (data) {
                        self._updateLocalStorage(listener, data);
                        self._receive(data);
                    }
                });
                return this.xhr;
            },
            /**
             * Checks if the data in the local storage is up to date.
             *
             * @param {string} listener
             *
             * @returns {boolean} true, if the data in the local storage is valid
             * @private
             */
            _isDataValid: function (listener) {
                var listenerTimeout = this.listeners[listener].getTimeout();
                var currentTime = (new Date()).getTime();
                var poDataField = this._makeLocalStorageItemName(listener, 'po-data');
                var poDataLoadedAtField = this._makeLocalStorageItemName(listener, 'po-data-loaded-at');
                return (poDataField in localStorage) &&
                    (poDataLoadedAtField in localStorage) &&
                    (currentTime - parseInt(localStorage[poDataLoadedAtField]) < listenerTimeout);
            },
            /**
             * Checks if a PO request must be sent.
             * It can be that the data in the localStorage is not valid anymore, but a PO request, for the listener, was
             * already sent and the process is just waiting for feedback.
             *
             * @param {string} listener
             *
             * @returns {boolean} true if a PO request should be sent
             * @private
             */
            _shouldSendPO: function (listener) {
                var currentTime = (new Date()).getTime();
                var lastPoRequestAtField = this._makeLocalStorageItemName(listener, 'last-po-request-at');
                return !(lastPoRequestAtField in localStorage) ||
                    (lastPoRequestAtField in localStorage) &&
                    (currentTime - parseInt(localStorage[lastPoRequestAtField]) >= this.poRequestTimeout);
            },
            /**
             * Makes the localStorage item name.
             *
             * @param {string} listener
             * @param {string} itemName
             * @return {string}
             * @private
             */
            _makeLocalStorageItemName: function (listener, itemName) {
                return listener + '-' + itemName;
            },
            /**
             * Updates the information in the localStorage.
             *
             * @param {string} listener
             * @param {object} data
             * @private
             */
            _updateLocalStorage: function (listener, data) {
                if (data.hasOwnProperty('listeners')) {
                    var poDataField = this._makeLocalStorageItemName(listener, 'po-data');
                    var poDataLoadedAtField = this._makeLocalStorageItemName(listener, 'po-data-loaded-at');

                    localStorage.setItem(poDataLoadedAtField, (new Date()).getTime().toString());
                    localStorage.setItem(poDataField, JSON.stringify(data.listeners[listener]));
                } else {
                    this._removeListenerItemsFromLocalStorage(listener);
                }
            },
            /**
             * Reads the data from the localStorage and parses it into an object.
             *
             * @param {string} listener
             * @return {object}
             * @private
             */
            _readDataFromLocalStorage: function (listener) {
                var poDataField = this._makeLocalStorageItemName(listener, 'po-data');
                var data = {};

                if (localStorage.getItem(poDataField) !== null && localStorage[poDataField] !== 'undefined') {
                    data[listener] = JSON.parse(localStorage[poDataField]);
                }
                return data;
            },
            /**
             * Removes the listener items from the localStorage.
             *
             * @param listener
             * @private
             */
            _removeListenerItemsFromLocalStorage: function (listener) {
                var poDataField = this._makeLocalStorageItemName(listener, 'po-data');
                var poDataLoadedAtField = this._makeLocalStorageItemName(listener, 'po-data-loaded-at');
                var lastPoRequestAtField = this._makeLocalStorageItemName(listener, 'last-po-request-at');

                localStorage.removeItem(poDataField);
                localStorage.removeItem(poDataLoadedAtField);
                localStorage.removeItem(lastPoRequestAtField);
            }
        };
    }
    ;
    return {
        // Get the Singleton instance if one exists
        // or create one if it doesn't
        getInstance: function () {

            if (!instance) {
                instance = init();
            }

            return instance;
        }

    };

})();

var ns = namespace('Esearcher.Layout');

/**
 * Diese Klasse ermoeglicht das Ausfuehren von Code beim Vorhandensein eines
 * definierten Layouts (z. B. soll bestimmtes JavaScript nur bei Layout XY
 * ausgefuehrt werden, also nutzt man diesen Handler um das festzulegen).
 *
 * Hier gehoert kein layout-spezifischer Code rein!
 *
 * @author Nabil Krause
 */
ns.LayoutHandler = function() {

    this.bindings = {};
    this.init();
};

ns.LayoutHandler.prototype.init = function() {

    var self = this;

    $(function () {
        // we will use the modern as default theme!
        var theme = 'modern';
        var masterTheme = $('body').attr('data-layout');
        var secondTheme = $('body').attr('data-layout-second');
        if (masterTheme && self.bindings[masterTheme]) {
            theme = masterTheme;
        }
        else if (secondTheme && self.bindings[secondTheme]) {
            theme = secondTheme;
        }
        if (self.bindings[theme]) {
            $(self.bindings[theme]).each(function (idx, el) {
                (typeof el === 'function') && el();
            });
        }
    });
};

/**
 *
 * @param {type} layout
 * @param {type} func
 * @returns {undefined}
 */
ns.LayoutHandler.prototype.on = function(layout, func) {

    if (!this.bindings[layout]) {
        this.bindings[layout] = [];
    }

    this.bindings[layout].push(func);
};

var ns = namespace('Esearcher.Layout');

/**
 * Instanz der LayoutHandler erstellen, sodass diese innerhalb der Anwendung
 * genutzt werden kann.
 */
ns.handler = new ns.LayoutHandler();

var ns = namespace('Esearcher.Helper');

ns.HtmlEncodingDecodingHelper = function () {};

/**
 * Encodes the text in the value with html entities. The div is basically created in memory but is never appended to the document.
 * But with this div element we can call the html and text function of jquery to encode the string.
 *
 * @param value The string to encode.
 * @returns The encoded string.
 */
ns.HtmlEncodingDecodingHelper.prototype.encode = function (value) {
    return $('<div />').text(value).html();
};

/**
 * Decodes html entities in the value. The div is basically created in memory but is never appended to the document.
 * But with this div element we can call the html and text function of jquery to decode the string.
 *
 * @param value The encoded string (contains html entities e.g.).
 * @returns The decoded html string.
 */
ns.HtmlEncodingDecodingHelper.prototype.decode = function (value) {
    return $('<div />').html(value).text();
};
var ns = namespace('Esearcher.Helper');

ns.htmlEncodingDecoding = new ns.HtmlEncodingDecodingHelper();

var ns = namespace('Esearcher.Helper');

ns.NavigationHelper = function (navigationRoute) {
    this.navigationRoute = navigationRoute;
};

/**
 * Berechnet eine URI zur History-basierten Navigation.
 *
 * @param {String} from Seite, die in der History gespeichert werden soll
 * @param {String} to Seite, zu der die URI leiten soll
 * @returns {String}
 */
ns.NavigationHelper.prototype.uri = function (from, to) {
    return this.navigationRoute + '?from=' + encodeURIComponent(from)
             + '&to=' + encodeURIComponent(to);
};

/**
 * Wie uri(), jedoch wird die Weiterleitung direkt ausgefuehrt.
 *
 * @param {String} from
 * @param {String} to
 */
ns.NavigationHelper.prototype.redirect = function (from, to) {
    var uri = this.uri(from, to);
    location.href = uri;
};

/**
 * Ruft die zuletzt in der Session gespeicherte Seite auf.
 */
ns.NavigationHelper.prototype.back = function () {
    location.href = this.navigationRoute + 'back';
};

var ns = namespace('Esearcher.Helper');

ns.navigation = new ns.NavigationHelper('/navigation/');

var ns = namespace('Esearcher.Helper');

ns.UrlHelper = function () {};

/**
 * Builds a query for get parameters in the url. All values will be encoded.
 * Because we have to use the window.location object, the page will be reloaded after calling this method.
 *
 * @param {Object} parameters A key-value-object. E.g. {profileId: 123, testString: 'This is a test'}
 * @param {Boolean} traditional A Boolean indicating whether to perform a traditional "shallow" serialization (@see http://api.jquery.com/jquery.param/)
 */
ns.UrlHelper.prototype.buildQuery = function (parameters, traditional) {
    traditional = typeof traditional === 'undefined' ? false : traditional;

    var encodedParams = {};
    $.each(parameters, function(key, value) {
        encodedParams[key] = encodeURIComponent(value);
    });

    window.location.search = '?' + $.param(encodedParams, traditional);
};

/**
 * Removes all queries from the url (but not the hash). After this, the page is reloading because we have to use the window.location object.
 */
ns.UrlHelper.prototype.removeQuery = function () {
    window.location = window.location.pathname + window.location.hash;
};

/**
 * Gets a Parameter value from the url.
 * @see http://stackoverflow.com/questions/19491336/get-url-parameter-jquery-or-how-to-get-query-string-values-in-js/21903119#21903119
 *
 * @param {String} parameter The key of the GET-parameter.
 * @returns {String} The value of the given parameter or an empty string if the key has no value (e.g. ?test#abc) or if it is not found.
 */
ns.UrlHelper.prototype.getParameterValue = function (parameter) {
    var sPageUrl = decodeURIComponent(window.location.search.substring(1)),
        sUrlVariables = sPageUrl.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sUrlVariables.length; i++) {
        sParameterName = sUrlVariables[i].split('=');

        if (sParameterName[0] === parameter) {
            return sParameterName[1] === undefined ? '' : sParameterName[1];
        }
    }
    return '';
};
/**
 * Stellt eine Instanz des UrlHelpers bereit.
 */

var ns = namespace('Esearcher.Helper');

ns.url = new ns.UrlHelper();

var ns = namespace('Esearcher');

/**
 * Der BlockLoader laedt einzelne Bloecke via AJAX nach und fuegt diese in das
 * Dokument ein. Anschliessend wird die Callback-Funktion aufgerufen, sofern
 * diese gesetzt wurde.
 *
 * @author Nabil Krause
 */
ns.BlockLoader = function() {
    this.response = null;
    this.map = {};
    this.doProcessAssets = false;
    this.assetKeys = {
        scripts: '__scripts',
        styles: '__styles'
    };
    this.scriptsContainer = $('head');
    this.stylesContainer = this.scriptsContainer;
};

/**
 * Ermoeglicht das Setzten einer Callback-Funktion, welche nach verarbeiteter
 * Response aufgerufen wird.
 *
 * @param {Function} callback Die Callback-Funktion
 */
ns.BlockLoader.prototype.setCallback = function(callback) {

    this.callback = callback;
    return this;
};

/**
 * Bestimmt, ob Assets in der Response (scripts, styles) verarbeitet werden
 * sollen.
 *
 * @param {Bool} doProcess
 */
ns.BlockLoader.prototype.setAssetProcessing = function(doProcess) {

	this.doProcessAssets = !!doProcess;
    return this;
};

/**
 * Setzt den Container, in welchem nach zu ersetzenden und einfuegenden Scripts
 * zu suchen ist (sofern asset processing aktiv ist).
 */
ns.BlockLoader.prototype.setScriptsContainer = function(container) {

    this.scriptsContainer = container;
    return this;
};

/**
 * Setzt den Container, in welchem nach zu ersetzenden und einfuegenden Styles
 * zu suchen ist (sofern asset processing aktiv ist).
 */
ns.BlockLoader.prototype.setStylesContainer = function(container) {

    this.stylesContainer = container;
    return this;
};

/**
 * Bestimmt die Zuordnungen der von der Response erwarteten Blocke zu aktuell
 * im HTML vorhandenen Bloecken. Letztere werden dabei mit dem HTML der Response
 * gefuellt.
 *
 * @param {Object} map
 */
ns.BlockLoader.prototype.mapBlocks = function(map) {

	$.extend(this.map, map);
    return this;
};


ns.BlockLoader.prototype.request = function(url, params, method, loadingOverlay) {

    var self = this;

    if ('undefined' === typeof method) {
        method = 'GET';
    } else {
        method = method.toUpperCase();
    }

    if ('undefined' === typeof loadingOverlay) {
        loadingOverlay = false;
    }

    $.ajax({
        url: url,
        data: params,
        type: method,
        loadingOverlay: loadingOverlay
    }).done(function(data) {
        self.response = data;
        if (typeof data === 'object' && typeof data.redirect != 'undefined') {
            window.location.href = window.location.origin + '/' + data.redirect;
        }
        try {
            self.process(data, self);
            self.callback && self.callback(true);
        } catch (e) {
            console.error('Blockloader error!');
            console.error(e);
            console.error('Response-Data:', data);
            console.error(this);
            var errMsg = '<p>' + data.toString() + '</p>';

            $(document).trigger('blockLoadError', errMsg);
            self.callback && self.callback(false);
        }
        $('select').not('*[data-no-chosentransform="1"]').chosen({disable_search_threshold: 0});
    }).fail(function (e) {
        $(document).trigger('blockLoadError', e.responseText);
        self.callback && self.callback(false);
    });

    $(document).trigger('loadStart');
};

/**
 * Verarbeitet die empfangenen Bloecke.
 *
 * @param {jQuery} data
 */
ns.BlockLoader.prototype.process = function(data) {

    var self = this;

    if (typeof(data) === 'object') {
        $.each(data, function (key, obj) {

            if (self.map.hasOwnProperty(key)) {

                self.map[key].html(data[key]);
            } else if ((key === self.assetKeys.scripts ||
                key === self.assetKeys.styles) && self.processAssets) {

                self.processAssets($(obj));
            }
        });
    }
    $(document).trigger('loadFinish', data);
};

ns.BlockLoader.prototype.processAssets = function(assets) {

    if (assets.first().prop('tagName') === 'LINK') {
        this.replaceLinkTags(assets);
    } else if (assets.first().prop('tagName') === 'SCRIPT') {
        this.addScriptTags(assets);
    }
};

/**
 * Ersetzt die link-Tags durch die neuen, bereits vorhandene werden nicht
 * angefasst.
 *
 * @param {jQuery} newLinks
 */
ns.BlockLoader.prototype.replaceLinkTags = function(newLinks) {

    var self = this;

    newLinks.each(function(idx, el) {

        var href = $(el).attr('href');

        if (self.stylesContainer.find('link[href="' + href + '"]').notExists()) {
            self.stylesContainer.append('<link href="' + href + '" rel="stylesheet" type="text/css" />');
        }
    });

};

/**
 * Fuegt die neuen script-Tags ein, bereits vorhandene werden nicht
 * angefasst.
 *
 * @param {jQuery} newScripts
 */
ns.BlockLoader.prototype.addScriptTags = function(newScripts) {

    var self = this;

    newScripts.each(function(idx, el) {

        var src = $(el).attr('src');

        if (self.scriptsContainer.find('script[src="' + src + '"]').notExists()) {
            self.scriptsContainer.append('<script src="' + src + '" />');
        }
    });
};

var ns = namespace('Esearcher');


ns.DataApplier = function() {};

/**
 * Bindet ein Select-Element zu einem Text-Input. Wird beim Select die
 * Auswahl geändert, wird diese in das Text-Feld übertragen (nur falls value
 * !== '').
 *
 * @param {jQuery} select
 * @param {jQuery} text
 */
ns.DataApplier.prototype.bindSelectToText = function(select, text) {

    $(select).on('change', function(e) {

        var selected = $(this).find('option:selected');

        if (selected.val() !== '') {
            text.val(selected.text());
        }
    });
};

var ns = namespace('Esearcher');

/**
 * Fadet Nachrichten nach kurzer Zeit aus.
 *
 * @param {String} selector jQuery-Selector fuer die auszufadenden Nachrichten.
 * @returns {MessageFader}
 */
ns.MessageFader = function(selector) {
    this.selector = selector;
};

/**
 * Durchsucht das uebergebene Element nach Nachrichten und fadet diese
 * nacheinander aus.
 *
 * @param {jQuery} el Das zu bearbeitende Element
 */
ns.MessageFader.prototype.process = function(el) {

    var messages       = el.find(this.selector).reverse();
    var delayOfCurrent = 0;

    messages.each(function(idx, el) {

        setTimeout(function() {
            $(el).fadeOut();
        }, 1600 + delayOfCurrent);

        delayOfCurrent += 700;
    });
};

var ns = namespace('Esearcher');

/**
 * Klasse fuer Popups.
 */

/**
 * @param {string} url
 * @param {string} title
 * @param {number} width
 * @param {number} height
 * @param {bool} showMenu
 * @returns {Popup}
 */
ns.Popup = function(url, title, width, height, showMenu) {

    this.url = url;
    this.title = title;
    this.defaultWidth = 760;
    this.defaultHeight = 570;
    this.setWidth(width);
    this.setHeight(height);
    this.setShowMenu(showMenu);
};

/**
 * Setzt die Breite des Popups.
 *
 * @param {Number} width
 * @returns {Popup.prototype}
 */
ns.Popup.prototype.setWidth = function(width) {
    this.width = width;
};

/**
 * Setzt die Hoehe des Popups.
 *
 * @param {Number} height
 * @returns {Popup.prototype}
 */
ns.Popup.prototype.setHeight = function(height) {

    this.height = (typeof height !== 'undefined') ? height : this.defaultHeight;
    return this;
};

/**
 * Bestimmt, ob bei dem Popup ein Menue zu sehen sein soll.
 *
 * @param {Bool} showMenu
 * @returns {Popup.prototype}
 */
ns.Popup.prototype.setShowMenu = function(showMenu) {

    this.showMenu = (showMenu === true) ? 'yes' : 'no';
    return this;
};

/**
 * Zeigt das Popup an.
 *
 * @returns {Popup.prototype}
 */
ns.Popup.prototype.show = function() {

	window.open(this.url, this.title, 'toolbar=no,location=no,directories=no,status=no,menubar=' +
        this.showMenu + ',scrollbars=yes,resizable=yes,copyhistory=no,width=' + this.width +
        ',height=' + this.height +',screenX=10,screenY=10,top=10,left=10');

    return this;
};

var ns = namespace('Esearcher');

ns.SearchListControl = function() {

    this.uri = '/settings/toggle-search-list-fold';
    this.activeElement = null;
};

/**
 * Initialisiert die Buttons (Eventhandler-Registrierung).
 *
 * @returns {undefined}
 */
ns.SearchListControl.prototype.init = function() {

    var self = this;

    $(document).on('click', '.toggleFoldOptionButton', function() {
        self.activeElement = $(this);
        self.activeElement.addClass('loading');
        self.sendToggleRequest();
    });
};

/**
 * Gibt zurueck, ob die Suchoptionen eingeklappt sind. Funktioniert nur,
 * wenn activeElement gesetzt ist (z. B. im Click-Handler).
 *
 * @returns {Bool}
 */
ns.SearchListControl.prototype.isFolded = function() {
	return !this.activeElement.parents('.panel').find('#toggleSearch').hasClass('in');
};

ns.SearchListControl.prototype.sendToggleRequest = function() {

    var self = this;

    $.post(this.uri, {isFolded: this.isFolded()}, function(data) {
        self.activeElement.removeClass('loading');
    });
};


Esearcher._onData = [];

/**
 * Bindet bestimmte Events.
 *
 * Unterstuetzte Events:
 *   tab [tabName] func - Nach erfolgreichem Laden eines Tabs.
 *
 * @param {String} eventName
 * @returns {Esearcher}
 */
Esearcher.on = function(eventName, arg1, arg2) {

    if (Esearcher._supportedEvents.indexOf(eventName) !== -1) {

        var eventHandler = {
            eventName: eventName,
            tab: null,
            func: null
        };

        if (typeof arg1 === 'string') {
            eventHandler.tab = arg1;
            eventHandler.func = arg2;
        } else {
            eventHandler.func = arg1;
        }

        Esearcher._onData.push(eventHandler);

        return this;
    }

    throw new Error('Event ' + eventName + ' is unkown. ' +
            'Maybe you intended to use a jQuery-Event?');
};

/**
 * Removes the event from the Esearcher event array.
 *
 * @param eventName
 * @returns {Esearcher}
 */
Esearcher.off = function (eventName) {
    var localEventName = eventName;

    Esearcher._onData = Esearcher._onData.filter(function (value) {
        return localEventName !== value.eventName;
    });

    return this;
};

/**
 * body braucht ein Attribut data-page mit der page-id.
 */

/**
 * Hier werden alle Objekte fuer die Seiten gespeichert.
 */
Esearcher.pages = [];

/**
 * Ermoeglicht das Hinzufuegen von Funktionen fuer bestimmte Seiten bzw. das
 * Holen aller definierten Seiten.
 */
Esearcher.page = function (id, func) {

    if (typeof func !== 'function') {
        throw new Error('Invalid function passed for page with id ' + id);
    }

    Esearcher.pages.push({
        id: id,
        run: func
    });

    return this;
};


/**
 * Erlaubt das Triggern Esearcher-spezifischer Events.
 *
 * @param {String} eventName Name des zu triggernden Events
 * @param {Object} data Daten fuer das Event
 * @returns {Esearcher}
 */
Esearcher.trigger = function (eventName, data) {

    if (Esearcher._supportedEvents.indexOf(eventName) !== -1) {
        Esearcher._onData.forEach(function (handler) {

            if (handler.eventName === eventName &&
                    (handler.tab === null || handler.tab === data.tab)) {
                handler.func.call(Esearcher, data);
            }
        });

        return this;
    }

    throw new Error('Event ' + eventName + ' is unkown. ' +
            'Maybe you intended to trigger a jQuery-Event?');
};

// "private" Property mit den unterstuetzten Events
Esearcher._supportedEvents = ['tab', 'tabFinish', 'save', 'saveFinish'];

var ns = namespace('Esearcher.Helper');

/**
 * Ein jQuery-basierter Helper, um Elemente eines Formulars anzusprechen.
 * Vorteil: Wird die Formular-ID angepasst, muessen nicht alle Element-IDs im JS
 * angepasst werden, sofern mit diesem Helper gearbeitet wurde.
 *
 * @param {String} formId
 */
ns.Form = function(formId) {
    this.form = null;
    this.formId = formId;
};

/**
 * Gibt das Form zurueck. Hierbei wird ueberprueft, ob das Form (noch) existiert
 * und nur falls dem nicht so ist wird ein neues Objekt zurueckgegeben.
 *
 * @returns {jQuery}
 */
ns.Form.prototype.getForm = function () {

    var isFormInDom = this.form !== null && $.contains(document.documentElement,
            this.form[0]);

    if (!isFormInDom) {
        this.form = $('#' + this.formId);
    }

    return this.form;
};

/**
 * Gibt das Element mit der angegebenen kurz-ID zurueck.
 *
 * @param {String} shortElementId NICHT die HTML-ID, sondern die aus dem Backend
 * @returns {jQuery}
 */
ns.Form.prototype.get = function(shortElementId) {
    shortElementId = shortElementId.replace(/\[/g, '\\[').replace(/\]/g, '\\]');
    return this.getForm().find('#' + this.formId + this.ucfirst(shortElementId));
};

/**
 * Eine Facade fuer $(document).on(evtName, elementId, handler), wobei elementId
 * automatisch berechnet wird. Desweiteren wird der Kontext des Event-Handlers
 * so veraendert, dass $(this) auf das gewuenschte Element und nicht auf document
 * weist.
 *
 * @param {String} evtName
 * @param {String} shortElementId
 * @param {Function} handler
 * @returns {Form}
 */
ns.Form.prototype.on = function (evtName, shortElementId, handler) {

    if (typeof evtName !== 'string' || typeof shortElementId !== 'string' ||
            typeof handler !== 'function') {
        throw new Error('Please pass correct arguments to Form.on');
    }

    $(document).on(evtName, '#' + this.formId + this.ucfirst(shortElementId),
            function (e) {
        handler.apply(e.target, arguments);
    });

    return this;
};

/**
 * Konvertiert den ersten Buchstaben des uebergebenen Strings zu lowerCase und
 * gibt den String zurueck.
 *
 * Entiwckler-Hinweis: Bei Gelegenheit auslagern.
 *
 * @param {String} str
 * @returns {String}
 */
ns.Form.prototype.ucfirst = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Resettet die Elemente mit den angegebenen kurz-IDs (es koennen beliebig viele
 * Argumente uebergeben werden).
 * Dazu wird das Element analysiert und je nach Element folgendes gemacht:
 *   Select:                               Auswählen der ersten Option
 *   Textartige Inputs, Textarea/CKEditor: Setzen auf leeren String
 *   Radios/Checkboxen:                    Alle unchecken
 *
 * Ggf. sind Spazial-Anpassungen notwendig (z. B. bei Radios), da muss dann
 * mittels Form::get() gearbeitet werden.
 *
 * @param {...String} shortElementId1 NICHT die HTML-ID, sondern die aus dem Backend
 * @returns {Form}
 */
ns.Form.prototype.reset = function(shortElementId1) {
    for (var i = 0; i < arguments.length; i++) {
        var shortElementId = arguments[i];
        var el = this.get(shortElementId);
        var tagName = el.prop('tagName').toLowerCase();

        if (tagName === 'input' && (el.attr('type') !== 'radio' &&
                el.attr('type') !== 'checkbox')) {
            el.val('');
        } else if (tagName === 'input') {
            el.prop('checked', false);
        } else if (tagName === 'select') {
            el.val(el.find('option:first').val());
            el.trigger('chosen:updated');
        } else if (tagName === 'textarea') {

            el.html('');

            var ckProp = this.formId + this.ucfirst(shortElementId);

            if (typeof CKEDITOR !== 'undefined' &&
                    CKEDITOR.instances.hasOwnProperty(ckProp)) {
                CKEDITOR.instances[ckProp].setData('');
            } else {
                el.val('');
            }
        }
    }

    return this;
};

var ns = namespace('Esearcher.Helper');

ns.findHighestZIndex = function () {
    var positions = ["absolute", "fixed"];

    return Math.max.apply(
        null,
        $.map(
            $('body *'),
            function (element, index) {
                if (positions.indexOf($(element).css('position')) > -1) {
                    return parseInt($(element).css('z-index')) || 1;
                }
            }
        )
    );
};
var nameSpace = namespace('Esearcher.Layout');

nameSpace.getWindowHeight = function () {
    var myHeight = 0;
    if (typeof (window.innerWidth) == 'number') {
        //Non-IE
        myHeight = window.innerHeight;
    } else if (document.documentElement &&
        (document.documentElement.clientWidth || document.documentElement.clientHeight)
    ) {
        //IE 6+ in 'standards compliant mode'
        myHeight = document.documentElement.clientHeight;
    } else if (document.body && (document.body.clientWidth || document.body.clientHeight)) {
        //IE 4 compatible
        myHeight = document.body.clientHeight;
    }
    return myHeight;
};

nameSpace.getWindowWidth = function () {
    var myWidth = 0;
    if (typeof (window.innerWidth) == 'number') {
        //Non-IE
        myWidth = window.innerWidth;
    } else if (document.documentElement &&
        (document.documentElement.clientWidth || document.documentElement.clientHeight)
    ) {
        //IE 6+ in 'standards compliant mode'
        myWidth = document.documentElement.clientWidth;
    } else if (document.body && (document.body.clientWidth || document.body.clientHeight)) {
        //IE 4 compatible
        myWidth = document.body.clientWidth;
    }
    return myWidth;
};
var ns = namespace('Esearcher.Template');

/**
 * Parst einfache String-Templates mit den angegebenen Variablen.
 *
 * @param {String} template
 * @param {Object} vars
 * @returns {String}
 */
ns.parse = function (template, vars) {

    var result = (typeof template === 'string') ? template : '';

    Object.keys(vars).forEach(function (el) {

        // kein RegEx-Replace, da sonst ggf. Escaping noetig waere

        var search = '{{' + el + '}}';

        while (result.indexOf(search) > -1) {
            result = result.replace(search, vars[el]);
        }
    });

    return result;
};

var ns = namespace('Esearcher.Ui');

ns.Notifier = function() {
    this.container = $('#tabHeader');

    this.titleMap = Cookies.getJSON('notify_title_text');
};

/**
 * Wenn alles gut lief
 */
ns.Notifier.TYPE_INFO = 'notice';

/**
 * Wenn es Fehler gab
 */
ns.Notifier.TYPE_ERROR = 'error';

/**
 * Warnung; nicht so granvierend wie Fehler
 */
ns.Notifier.TYPE_WARNING = 'warning';

/**
 * Neutrale Meldung
 */
ns.Notifier.TYPE_DEFAULT = 'default';

/**
 *
 * Keine Meldnung! Kann als Rückkanal genutzt werden.
 */
ns.Notifier.TYPE_REPORT = 'report';

/**
 * "Statische" Methode zum Abrufen der Instanz.
 *
 * @returns {Esearcher.Ui.Notifier}
 */
ns.Notifier.getInstance = function () {

    var ns = Esearcher.Ui.Notifier;
    if (!ns.instance) {
        ns.instance = new Esearcher.Ui.Notifier();
    }

    return Esearcher.Ui.Notifier.instance;
};

/**
 * Fuegt eine Notification hinzu. Funktioniert nur auf Tab-Seiten bzw. solchen
 * mit der passenden HTML-Struktur.
 *
 * @param {String} msg
 * @param {Number} type
 * @param {Number} duration Optionale Anzeigedauer in ms. Default sind 3000.
 *                          0 fuer dauerhafte Anzeige (bis Tabwechsel).
 * @returns {Esearcher.Ui.Notifier}
 */
ns.Notifier.prototype.notify = function(msg, type, duration) {
    type = type || Esearcher.Ui.Notifier.TYPE_INFO;
    if (type === 'error') {
        duration = typeof duration === 'undefined' ? 0 : duration;
    }
    if (type === 'notice') {
        duration = typeof duration === 'undefined' ? 3000 : duration;
    }
    if (type === 'warning') {
        duration = typeof duration === 'undefined' ? 6000 : duration;
    }

    var params = {
        message: msg
    };

    if (duration === 0) {
        params.fixed = true;
    } else {
        params.duration = duration;
    }

    params.title = this.titleMap[type];

    if (type != Esearcher.Ui.Notifier.TYPE_REPORT) {
        if (type === Esearcher.Ui.Notifier.TYPE_DEFAULT) {
            $.growl(params);
        } else {
            $.growl[type](params);
        }
    }

    return this;
};

/**
 * Entfernt alle Notifications.
 *
 * @returns {Esearcher.Ui.Notifier}
 */
ns.Notifier.prototype.clearAll = function () {
    $('#growls').remove();
};

/**
 * JavaScript fuer das Hauptmenue
 */
Esearcher.Layout.handler.on('classic', function() {

    $('#navigation').sortable({
        update: function() {

            var prefix = 'group_';

            var ids = $.map($('.menuGroup[data-menu-group-id]'), function(el) {
                return prefix + $(el).attr('data-menu-group-id');
            });

            $.post('/user_profil_subadmin_ajax.php', {
                action:	'sort',
                order: ids
            });
        }
    });

    $('*[data-menu-group-toggle-activated="true"]').find('.heading')
            .append('<button class="toggle"></button>');

    $('[data-menu-group-displayed="0"]').each(function (idx, el) {

        $(el).find('.heading')
            .find('.toggle')
            .addClass('hidden')
            .parent()
            .nextAll()
            .slideToggle()
            .parents('.menuGroup')
            .toggleClass('collapsed');
    });

    $(document).on('click', '.menuGroup .toggle', function() {
        $(this).toggleClass('hidden').parents('.heading').nextAll()
                .slideToggle().parents('.menuGroup')
                .toggleClass('collapsed');

        var isCollapsed = $(this).parents('.menuGroup').hasClass('collapsed');
        var groupId = $(this).parents('.menuGroup').attr('data-menu-group-id');

        $.post('/user_profil_subadmin_ajax.php', {
            action: 'fold',
            show: isCollapsed ? 0 : 1,
            group: 'group_' + groupId
        });
    });

    /**
     * Suchfelder im Menue: Numerische Eingaben als ID erkennen.
     */
    $('.sidebarSearch').on('submit', function() {

        var field            = $(this).find('.searchField'),
            numericFieldName = 'searchField[' + $(this)
                    .attr('data-numeric-field') + ']';

        if (!isNaN(field.val())) {
            $(this).find('input[name="' + numericFieldName + '"]')
                    .val(field.val());
            field.val('');
        }
    });
});

$(document).ready(function () {
    // title inheritance is not implemented in icheck 1.* but this works
    // @see https://github.com/fronteed/icheck/issues/96
    $(document).on('ifCreated', 'input', function() {
        if (this.title) {
            $(this).parent().attr('title', this.title);
        }
    });

    parseCheckboxes();

});

$(document).on('loadFinish', function () {
    parseCheckboxes();
});

function parseCheckboxes() {
    $('input:not(.toggle):not(.no-ready)').iCheck({
        checkboxClass: 'checkbox-square',
        radioClass: 'radio-square',
        increaseArea: '20%' // optional
    });
    var checkboxToggle = $('input.toggle');
    $.each(checkboxToggle, function () {
        if ($(this).prop("style")['opacity'] === "") {
            $(this).iCheck({
                        checkboxClass: 'checkbox-toggle',
                        radioClass: 'radio-toggle',
                        increaseArea: '20%' // optional
                    });
        }
    });

}
$(document).ready(function () {

    $("#taskPanel button.buttonCollapse").click(function () {
        if ($("#collapseTask").prop('style').height !== '0px') {
            $("#taskPanel ul li").removeClass('active');
        } else {
            if ($("#newTask").prop('style').display == 'block') {
                $("[aria-controls=newTask]").addClass('active');
            } else if ($("#futureTask").prop('style').display == 'block') {
                $("[aria-controls=futureTask]").addClass('active');
            } else if ($("#overdueTask").prop('style').display == 'block') {
                $("[aria-controls=overdueTask]").addClass('active');
            }
            ;
        }
        ;
    });

    $("#keyFiguresPanel button.buttonCollapse").click(function () {
        if ($("#collapseKeyFigures").prop('style').height !== '0px') {
            $("#keyFiguresPanel ul li").removeClass('active');
        } else {
            if ($("#interestedParties").prop('style').display == 'block') {
                $("[aria-controls=interestedParties]").addClass('active');
            } else if ($("#candidate").prop('style').display == 'block') {
                $("[aria-controls=candidate]").addClass('active');
            }
            ;
        }
        ;
    });

    $("#birthdayPanel button.buttonCollapse").click(function () {
        if ($("#collapseBirthday").prop('style').height !== '0px') {
            $("#birthdayPanel ul li").removeClass('active');
        } else {
            if ($("#birthdayTomorow").prop('style').display == 'block') {
                $("[aria-controls=birthdayTomorow]").addClass('active');
            } else if ($("#birthdayToday").prop('style').display == 'block') {
                $("[aria-controls=birthdayToday]").addClass('active');
            }
            ;
        }
        ;
    });

    $("#jobPanel button.buttonCollapse").click(function () {
        if ($("#collapseJobs").prop('style').height !== '0px') {
            $("#jobPanel ul li").removeClass('active');
        } else {
            if ($("#newJob").prop('style').display == 'block') {
                $("[aria-controls=newJob]").addClass('active');
            } else if ($("#oldJob").prop('style').display == 'block') {
                $("[aria-controls=oldJob]").addClass('active');
            }
            ;
        }});

    $("#recentLogPanel button.buttonCollapse").click(function () {
        if ($("#collapseRecentLog").prop('style').height !== '0px') {
            $("#recentLogPanel ul li").removeClass('active');
        } else {
            if ($("#candidatesLog").prop('style').display === 'block') {
                $("[aria-controls=candidatesLog]").addClass('active');
            } else if ($("#companiesLog").prop('style').display === 'block') {
                $("[aria-controls=companiesLog]").addClass('active');
            } else if ($("#projectsLog").prop('style').display === 'block') {
                $("[aria-controls=projectsLog]").addClass('active');
            } else if ($("#companyContactsLog").prop('style').display === 'block') {
                $("[aria-controls=companyContactsLog]").addClass('active');
            }
        }
    });


    $("#taskPanel li").click(function () {
        $("#collapseTask").show();
        $("#collapseTask").removeAttr('style');
        $('#collapseTask').addClass('in');
    });
    $("#keyFiguresPanel li").click(function () {
        $("#collapseKeyFigures").show();
        $("#collapseKeyFigures").removeAttr('style');
        $('#collapseKeyFigures').addClass('in');
    });
    $("#birthdayPanel li").click(function () {
        $("#collapseBirthday").show();
        $("#collapseBirthday").removeAttr('style');
        $('#collapseBirthday').addClass('in');
    });
    $("#jobPanel li").click(function () {
        $("#collapseJobs").show();
        $("#collapseJobs").removeAttr('style');
        $('#collapseJobs').addClass('in');
    });
});
Esearcher.Layout.handler.on('modern', function () {
    $('.table-responsive tbody tr').slice(-2).find('.dropdown').addClass('dropup');
});

Esearcher.Layout.handler.on('modern', function () {
    $('[widget~=dialog]').click(function () {
        $('.dialog').modal({
            show: true
        })
    });
    $(document).on('show.bs.modal', '.modal', function (event) {
        var zIndex = 1040 + (10 * $('.modal:visible').length);
        $(this).css('z-index', zIndex);
        setTimeout(function() {
            $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
        }, 0);
    });
});
/**
 * JavaScript fuer das Hauptmenue
 */

Esearcher.Layout.handler.on('modern', function () {
    // Offcanvas Sidebar in mobiler Ansicht

    function collapse() {
        var toggleElement = $('#wrapper');
        var storageName = "Esearcher.navigation.collapsed";

        // check state
        toggleElement.toggleClass('extend');
        var isExtended = toggleElement.hasClass('extend');

        // save extended status
        localStorage[storageName] = isExtended;
        Cookies.set(storageName, isExtended);

        // switch classes
        $('ul.nav.collapse').removeClass('in');
        $('a.menu-group-head').removeClass('collapsed');
        $('a.menu-group-head').addClass('collapsed');
        if ($('#wrapper').hasClass('extend')) {
            $('#top-navbar-toggle').removeClass('hide-quick-menu');
        } else {
            $('#top-navbar-toggle').addClass('hide-quick-menu');
        }
    }

    function collapseSidebarMenu() {
        if ($('#wrapper').hasClass('extend')) {
            $('ul.nav.collapse').removeClass('in');
            $('#wrapper').removeClass('extend');
        }

        // store last clicked navigation item or reset storage key
        if ($(this).hasClass("collapsed")) {
            localStorage["Esearcher.navigation.last_open_parent"] = $(this).prop("id");
            localStorage["Esearcher.navigation.last_open_target"] = $(this).data("target");
        } else {
            localStorage["Esearcher.navigation.last_open_parent"] = null;
            localStorage["Esearcher.navigation.last_open_target"] = null;
        }

    }

    $('a.menu-group-head').addClass('collapsed');
    $('[data-toggle=offcanvasExtended]').click(collapse);
    $('.menu-group-head').click(collapseSidebarMenu);
    var menuToggledByDefault = $('ul.sidebar-menu').data('menutoggeldbydefault');

    if (window.self === window.top &&
        typeof localStorage !== 'undefined') {
        if (typeof localStorage['Esearcher.navigation.collapsed'] != 'undefined' && !menuToggledByDefault) {
            if ($('#wrapper').hasClass('extend') != JSON.parse(localStorage['Esearcher.navigation.collapsed'])) {
                collapse();
            }
        }

        // open last clicked navigation block
        if (typeof localStorage["Esearcher.navigation.last_open_target"] !== "undefined"
            && typeof localStorage["Esearcher.navigation.last_open_parent"] !== "undefined") {
            $(localStorage["Esearcher.navigation.last_open_target"]).addClass("in");
            $("#" + localStorage["Esearcher.navigation.last_open_parent"]).removeClass("collapsed");
        }
    }

});


function resizeIframe(obj) {
    obj.style.height = obj.contentWindow.document.body.scrollHeight + 'px';
}

$(document).on('loadFinish', function () {
    $('[data-toggle="tooltip"]').tooltip({
        'delay': { show: 1000 }
    });
    var options = {
        trigger: "focus",
        container: 'body'
    };
    $('input[data-placement]').tooltip(options);
    options['placement'] = "right";
    $('input:not([data-placement])').tooltip(options);
});

/**
 * Allgemeines Bootstrap fuer Javascript.
 */

$(function() {

    var notifier = Esearcher.Ui.Notifier.getInstance();

    // Zeigt Notifications an
    var displayNotifications = function (messages) {

        try {
            Object.keys(messages).forEach(function (key) {
                messages[key].forEach(function (msg) {
                    notifier.notify(msg, key);
                });
            });
        } catch (e) {
            console.log('error while processing message: ');
            console.log(e);
        }
    };

    // Alte Notifications entfernen
    $(document).on('tabChange', function () {
        notifier.clearAll();
    });

    // loadFinish wird bei pageload (unten) und AJAX-reload getriggert.
    $(document).on('loadFinish', function(e, data) {

        if (typeof data === 'object' && typeof data.__messages !== 'undefined') {
            displayNotifications(data.__messages);
        }

        $('input[data-datepicker="true"], input.datepicker').datepicker({dateFormat: 'dd.mm.yy'});

        $('.dataApplier').each(function(idx, el) {

            (new Esearcher.DataApplier()).bindSelectToText($(el), $('#' + $(el).attr(
                    'data-reference-id')));
        });

        (new Esearcher.SearchListControl()).init();
    }).trigger('loadFinish');

    // Errorhandling-Popup bei AJAX-Requests
    $(document).on('blockLoadError', function (e, data) {

        var errorHtmlObj = $('<html />');
        errorHtmlObj.html(data.toString())
                .find('script')
                .remove();

        // auskommentieren, falls Developerbar im Debug-Popup gewuenscht ist.
        errorHtmlObj.find('#debug_head').remove();

        $('<div id="error-dialog" />').html(errorHtmlObj.html()).dialog({
            title: 'An error occured',
            width: '80%',
            close: function () {
                $(this).dialog('destroy').remove();
            }
        }).show();
    });

    /**
     * Fuehrt (nur) die von der aktuellen Seite benoetigten Funktionen aus.
     */
    var initPageLogic = function () {
        var curPage = $('body').attr('data-page');

        if (typeof curPage !== 'undefined') {
            for (var i = 0; i < Esearcher.pages.length; i++) {

                if (Esearcher.pages[i].id === curPage) {
                    Esearcher.pages[i].run.call(Esearcher);
                } else {
                    // nicht benoetigte pages entfernen, fuer garbage collection...
                    Esearcher.pages.splice(i--, 1);
                }
            }
        } else {
            // nicht benoetigte pages entfernen, fuer garbage collection...
            Esearcher.pages = [];
        }
    };

    initPageLogic();

    /**
     * ES3-1661 Firefox-Bugfix for loading the CKEditor in a Bootstrap dialog.
     * Otherwise some form fields are not selectable in popups (e.g. the popup for adding a link).
     *
     * http://stackoverflow.com/questions/14420300/bootstrap-with-ckeditor-equals-problems
     */
    $.fn.modal.Constructor.prototype.enforceFocus = function() {
        modal_this = this;
        $(document).on('shown.bs.modal', function (e) {
            if (modal_this.$element[0] !== e.target && !modal_this.$element.has(e.target).length
                && !$(e.target.parentNode).hasClass('cke_dialog_ui_input_select')
                && !$(e.target.parentNode).hasClass('cke_dialog_ui_input_text')) {
                modal_this.$element.focus();
            }
        })
    };

});

$(function() {

    $('.panelToggle').click(function() {
        var curIcon  = $(this).attr('src'),
            head     = $(this).closest('.panelHeading'),
            radius   = head.css('border-top-left-radius'),
            isHiding = (curIcon.indexOf('icon_hide') > -1),
            nextIcon;


        if (isHiding) {
            nextIcon = curIcon.replace('icon_hide', 'icon_show');
        } else {
            nextIcon = curIcon.replace('icon_show', 'icon_hide');
            head.removeClass('folded');
        }

        $(this).attr('src', nextIcon);

        $(this).closest('.panelHeading').next('.panelContent').slideToggle(function() {

            if (isHiding) {
                head.addClass('folded');
            }
        });
    });
});

/* window.location.origin might be empty for internet explorer users.
 * that's a problem with our block loader as it redirects if the json response contains the key "redirect".
 * such redirects are used for example in the /newapplicant, /newproject and /newcompany routes.
 *
 * @see BlockLoader.js
 * @see Esearcher\Controller\Applicant\TabController::saveApplicantAction()
 */
if (!window.location.origin) {
    window.location.origin =
        window.location.protocol + "//" + window.location.hostname +
        (window.location.port ? ':' + window.location.port : '');
}
/**
 * Hier koennen selbstdefinierte jQuery-Erweiterungen definiert werden.
 *
 * @author Nabil Krause
 */

/**
 * Kehrt die Reihenfolge Elemente in der aktuellen Auswahl um.
 */
jQuery.fn.reverse = [].reverse;

/**
 * Gibt zurueck, ob die aktuelle Auswahl mind. ein Element beinhaltet.
 *
 * @returns {Boolean}
 */
jQuery.fn.exists = function () {
    return this.length > 0;
};

/**
 * Gibt zurueck, ob die aktuelle Auswahl kein Element beinhaltet.
 *
 * @returns {Boolean}
 */
jQuery.fn.notExists = function () {
    return this.length === 0;
};

/**
 * Shows tooltips with html content just add class tooltipWithHtml.
 */
$(document).ready(function () {
    $('.tooltipWithHtml').tooltip({html: true});
});

/**
 * deserialize a from by a serialized form string
 *
 * @param {type} serializedString
 * @returns {$.fn}
 */
$.fn.deserialize = function (serializedString)
{
    var $form = $(this);
    $form[0].reset();    // (A) optional
    serializedString = serializedString.replace(/\+/g, '%20'); // (B)
    var formFieldArray = serializedString.split("&");

    // Loop over all name-value pairs
    $.each(formFieldArray, function (i, pair) {
        var nameValue = pair.split("=");
        var name = decodeURIComponent(nameValue[0]); // (C)
        var value = decodeURIComponent(nameValue[1]);
        // Find one or more fields
        var $field = $form.find('[name="' + name + '"]');
        // Checkboxes and Radio types need to be handled differently
        if ($field.length > 0) {
            if ($field[0].type == "checkbox" || $field[0].type == "radio") {
                $field.iCheck(value === 'on' ? 'check' : 'uncheck');
            } else if ($field.is('input') || $field.is('textarea')) { // input, textarea
                $field.val(value);
            }
            else if ($field.is('select')) {
                $field.find('option[value=' + value + ']').prop('selected', true);
                $field.trigger("chosen:updated");
            }
        }
    });
    return this;
}

/**
 * 
 * @param {string} status
 * @returns {void}
 */
$.overlay = function (status) {
    var overlayNode = $('body').find('#ajax-overlay');
    if (status === 'show' && overlayNode.length === 0) {
        $('body').prepend('<div id="ajax-overlay" class="ajax-overlay"><div class="ajax-outer"><div class="ajax-middle"><div class="ajax-inner updateLoaderIcon"></div></div></div></div>');
    }
    else if (status === 'remove' && overlayNode.length > 0) {
        overlayNode.remove();
    }
}
/**
 * Funktion, um einen Namespace zu definieren.
 *
 * @param {string} ns Namespace als Punkt separierter String.
 * @returns {Object} Gibt den definierten Namespace zurueck.
 */

function namespace(ns) {

    var parts       = ns.split('.'),
        parent      = window,
        currentPart = '',
        i           = 0,
        length      = parts.length;

    for (/* omitted */; i < length; i++) {
        currentPart         = parts[i];
        parent[currentPart] = parent[currentPart] || {};
        parent              = parent[currentPart];
    }

    return parent;
}

$(function() {

    var tooltips = $('.tooltip');

    tooltips.tooltipster && tooltips.tooltipster();
});

$(function () {
    $('.language-selector').on('click', function () {
        var self = this;
        var currentUrl = window.location.href;
        $.ajax({
            url: '/locale/set/',
            type: 'POST',
            dataType: 'json',
            data: {locale: $(self).data('locale')}
        }).done(function () {
            location.replace(currentUrl);
            location.reload();
        });
    });
});
/**
 * Simple gettext for javascript
 *
 * @see http://www.localeplanet.com/api/translate.js
 */
(function() {
    var translation = null;

    var gettext = function (text) {
        console.warn('Using gettext is a deprecated method!');
        if (translation === null || text === null || text in translation === false) {
            return $('<div/>').html(text).text();
        }
        res = translation[text];
        if (res === null) {
            return $('<div/>').html(text).text();
        }
        return res;
    };

    gettext.gettext = gettext;

    gettext.setTranslation = function(t) {
        translation = t;
    };

    window.gettext = gettext;
})();

$(function() {

    $('*[data-popup-activity]').on('click', function(e) {

        var id = $(this).attr('data-popup-activity');

        var pop = new Esearcher.Popup('aktion_view.php?aktion_id=' + id, 'Aktion');

        pop.show();

        e.preventDefault();
    });
});

Esearcher.page('applicantListing', function () {

    var ApplicantActionListUi = function () {
        this.applicantCheckboxes   = $('.applicantToMailingListCheck');
        this.applicantCheckboxesSelector = '.applicantToMailingListCheck';
        this.actionList            = $('#applicantListSelectMailingList');
        this.applyApplicantsButton = $('.applicantListMailingApplyApplicantsButton');
        this.emptyListButton       = $('.applicantListMailingDeleteButton');
        this.applicants            = [];
        this.selectMailingList     = $('.selectMailingList');
    };

    /**
     * Registriert alle notwendigen Event-Handler.
     *
     * @return {ApplicantActionListUi}
     */
    ApplicantActionListUi.prototype.initHandlers = function () {

        this.actionList.on('change',
                $.proxy(this.handleActionListChange, this));

        this.applyApplicantsButton.on('click',
                $.proxy(this.handleApplyApplicantsClick, this));

        this.emptyListButton.on('click',
                $.proxy(this.handleEmptyListClick, this));

        $(document).on('ifClicked', this.applicantCheckboxesSelector,
                $.proxy(this.handleApplicantChange, this));

        if (this.selectMailingList.val() === '0') {  // no action list is selected, so we have to hide the checkboxes
            this.hideCheckboxes();
        } else { // an action list is selected, so the checkboxes are visible and we have to trigger the selected option to get the associated data via ajax
            this.selectMailingList.change();
        }

        return this;
    };

    /**
     * Sets the active action list in the session.
     */
    ApplicantActionListUi.prototype.setActiveActionListInSession = function () {
        $.ajax({
            url: '/applicant/action-list/set-active-action-list',
            data: {
                actionListId: $('.selectMailingList').val()
            },
            method: 'POST'
        });
    };

    /**
     * Handler fuer eine Aenderung der gewaehlten Aktionsliste.
     */
    ApplicantActionListUi.prototype.handleActionListChange = function () {
        this.setActiveActionListInSession();

        if (!this.hasListSelected()) {
            this.hideCheckboxes();
        } else {
            this.getApplicants(function (data) {
                this.applicants = data;
                this.uncheckAllCheckboxes()
                    .checkCheckboxes()
                    .showCheckboxes();
            }.bind(this));
        }
    };

    /**
     * Handler fuer das Uebernehmen der gefundenen Bewerber auf die gewaehlte
     * Aktionsliste.
     */
    ApplicantActionListUi.prototype.handleApplyApplicantsClick = function () {

        if (this.hasListSelected()) {
            this.applyApplicants();
        }
    };

    /**
     * Handler fuer das Leeren der gewaehlten Aktionsliste.
     */
    ApplicantActionListUi.prototype.handleEmptyListClick = function () {

        if (this.hasListSelected()) {
            this.emptyList();
        }
    };

    /**
     * Handler fuer die Aenderung einer Bewerber-Auswahl.
     */
    ApplicantActionListUi.prototype.handleApplicantChange = function (e) {

        var el = $(e.currentTarget);
        var id = el.val();

        if (!el.is(':checked')) {
            this.addApplicant(id, function (success) {
                if (!success) {
                    el.prop('checked', false);
                }
            });
        } else {
            this.removeApplicant(id, function (success) {
                if (!success) {
                    el.prop('checked', true);
                }
            });
        }
    };

    /**
     * Deselektiert alle Checkboxen, die fuer die Aktionslisten relevant sind
     * (Bewerber).
     *
     * @return {ApplicantActionListUi}
     */
    ApplicantActionListUi.prototype.uncheckAllCheckboxes = function () {
        this.applicantCheckboxes.iCheck('uncheck');

        return this;
    };

    /**
     * Markiert die Checkboxen der in den uebergebenen Daten enthaltenen
     * Bewerber.
     *
     * @return {ApplicantActionListUi}
     */
    ApplicantActionListUi.prototype.checkCheckboxes = function () {

        var self = this;

        this.applicantCheckboxes.each(function (idx, el) {

            var applicantId = el.value;

            $.each(self.applicants, function (idx, curId) {

                if (curId == applicantId) {
                    $(el).iCheck('check');

                    // entspricht hier einem break
                    return false;
                }
            });
        });

        return this;
    };

    /**
     * Holt die Ansprechpartner-IDs fuer die gewaehlte
     * Aktionsliste.
     *
     * @param {Function} cb Callback, wird mit dem Ergebnis als erstem Parameter
     *                      aufgerufen
     *
     * @return {ApplicantActionListUi}
     */
    ApplicantActionListUi.prototype.getApplicants = function (cb) {

        var applicantIds = this.applicantCheckboxes.map(function (idx, el) {
            return this.value;
        }).get().join();

        if (applicantIds === '') {
            applicantIds = 0;
        }

        $.ajax({
            url: '/applicant/action-list/applicants/' + this.actionList.val() + '/' + applicantIds,
            method: 'GET',
            loadingOverlay: true
        }).done(function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            if (data.success) {
                cb(data.applicants);
            } else {
                cb([]);
            }
        });

        return this;
    };

    /**
     * Eine Firma zur ausgewaehlten Aktionsliste hinzufuegen.
     *
     * @param {Number} applicantId
     * @param {Function} cb Callback, wird mit Erfolgsstatus als Parameter
     *                      aufgerufen
     *
     * @return {ApplicantActionListUi}
     */
    ApplicantActionListUi.prototype.addApplicant = function (applicantId, cb) {

        $.post('/applicant/action-list/add-applicant/' + applicantId, {
            listId: this.actionList.val()
        }, function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            cb(data.success);
        });

        return this;
    };

    /**
     * Einen Bewerber von der ausgewaehlten Aktionsliste entfernen.
     *
     * @param {Number} applicantId
     * @param {Function} cb Callback, wird mit Erfolgsstatus als Parameter
     *                      aufgerufen
     *
     * @return {ApplicantActionListUi}
     */
    ApplicantActionListUi.prototype.removeApplicant = function (applicantId, cb) {

        $.post('/applicant/action-list/remove-applicant/' + applicantId, {
            listId: this.actionList.val()
        }, function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            cb(data.success);
        });

        return this;
    };

    /**
     * Alle gefundenen Bewerber zur Aktionsliste hinzufuegen.
     *
     * @return {ApplicantActionListUi}
     */
    ApplicantActionListUi.prototype.applyApplicants = function () {

        $.ajax({
            url: '/applicant/action-list/apply-all/' + this.actionList.val(),
            method: 'POST',
            loadingOverlay: true
        }).done($.proxy(function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            if (data.success) {

                var self = this;

                self.applicants = [];

                data.applicantIds.forEach(function (id) {
                    self.applicants.push(id);
                });

                this.checkCheckboxes();
            }
        }, this));

        return this;
    };

    /**
     * Leert die ausgewaehlte Aktionsliste von allen Bewerbern.
     *
     * @returns {ApplicantActionListUi}
     */
    ApplicantActionListUi.prototype.emptyList = function () {

        $.ajax({
            url: '/applicant/action-list/empty-all/' + this.actionList.val(),
            method: 'POST',
            loadingOverlay: true
        }).done($.proxy(function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            if (data.success) {
                this.applicants = [];
                this.uncheckAllCheckboxes();
            }
        }, this));

        return this;
    };

    /**
     * Gibt zurueck, ob eine Aktionsliste ausgewaehlt wurde.
     *
     * @returns {Boolean}
     */
    ApplicantActionListUi.prototype.hasListSelected = function () {
        return this.actionList.val() !== '0';
    };

    /**
     * Zeigt die Checkboxen vor den Bewerbern an.
     *
     * @return {ApplicantActionListUi}
     */
    ApplicantActionListUi.prototype.showCheckboxes = function () {
        this.applicantCheckboxes.removeClass('no-ready');
        this.applicantCheckboxes.parent().filter('.checkbox-square').show();

        parseCheckboxes();
        return this;
    };

    /**
     * Versteckt die Checkboxen vor Bewerbern.
     *
     * @return {ApplicantActionListUi}
     */
    ApplicantActionListUi.prototype.hideCheckboxes = function () {
        this.applicantCheckboxes.addClass('no-ready');
        this.applicantCheckboxes.parent().filter('.checkbox-square').hide();

        parseCheckboxes();
        return this;
    };

    var applicantActionList = new ApplicantActionListUi();

    applicantActionList.initHandlers();
});

Esearcher.page('companyListing', function () {

    var CompanyActionListUi = function () {
        this.companyCheckboxes         = $('.companyToMailingListCheck');
        this.companyCheckboxesSelector = '.companyToMailingListCheck';
        this.contactCheckboxesSelector = '.contactToMailingListCheck';
        this.actionList                = $('#companyListSelectMailingList');
        this.applyCompaniesButton      = $('.companyListMailingApplyCompaniesButton');
        this.applyContactsButton       = $('.companyListMailingApplyContactsButton');
        this.emptyListButton           = $('.companyListMailingDeleteButton');
        this.companiesWithContacts     = {};
        this.selectMailingList     = $('.selectMailingList');

        this.hideCheckboxes();
    };

    /**
     * Registriert alle notwendigen Event-Handler.
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.initHandlers = function () {

        this.actionList.on('change',
                $.proxy(this.handleActionListChange, this));

        this.applyCompaniesButton.on('click',
                $.proxy(this.handleApplyCompaniesClick, this));

        this.emptyListButton.on('click',
                $.proxy(this.handleEmptyListClick, this));

        $(document).on('ifClicked', this.companyCheckboxesSelector,
                $.proxy(this.handleCompanyChange, this));

        $(document).on('ifClicked', this.contactCheckboxesSelector,
                $.proxy(this.handleContactChange, this));

        this.actionList.on('companyContactsLoaded',
                $.proxy(this.handleContactsLoaded, this));

        this.applyContactsButton.on('click',
                $.proxy(this.handleApplyContactsClick, this));

        if (this.selectMailingList.val() === '0') { // no action list is selected, so we have to hide the checkboxes
            this.hideCheckboxes();
        } else { // an action list is selected, so the checkboxes are visible and we have to trigger the selected option to get the associated data via ajax
            this.selectMailingList.change();
        }

        return this;
    };

    /**
     * Sets the active action list in the session.
     */
    CompanyActionListUi.prototype.setActiveActionListInSession = function () {
        $.ajax({
            url: '/company/action-list/set-active-action-list',
            data: {
                actionListId: $('.selectMailingList').val()
            },
            method: 'POST'
        });
    };

    /**
     * Handler fuer eine Aenderung der gewaehlten Aktionsliste.
     */
    CompanyActionListUi.prototype.handleActionListChange = function () {
        this.setActiveActionListInSession();

        if (!this.hasListSelected()) {
            this.hideCheckboxes();
        } else {
            this.getCompaniesAndContacts(function (data) {
                this.companiesWithContacts = data;
                this.uncheckAllCheckboxes()
                    .checkCheckboxes()
                    .showCheckboxes();
            }.bind(this));
        }
    };

    /**
     * Handler fuer das Uebernehmen der gefundenen Firmen auf die gewaehlte
     * Aktionsliste.
     */
    CompanyActionListUi.prototype.handleApplyCompaniesClick = function () {

        if (this.hasListSelected()) {
            this.applyCompanies();
        }
    };

    CompanyActionListUi.prototype.handleApplyContactsClick = function () {
        if (this.hasListSelected()) {
            this.applyContacts();
        }
    };

    /**
     * Handler fuer das Leeren der gewaehlten Aktionsliste.
     */
    CompanyActionListUi.prototype.handleEmptyListClick = function () {

        if (this.hasListSelected()) {
            this.emptyList();
        }
    };

    /**
     * Handler fuer die Aenderung einer Firmen-Auswahl.
     */
    CompanyActionListUi.prototype.handleCompanyChange = function (e) {
        var el   = $(e.currentTarget);
        var id   = el.val();

        if (!el.is(':checked')) {
            this.addCompany(id, function (success) {
                if (!success) {
                    el.prop('checked', false);
                }
            });
        } else {
            this.removeCompany(id, function (success) {
                if (!success) {
                    el.prop('checked', true);
                }
            });
        }
    };

    /**
     * Handler fuer die Aenderung einer Ansprechpartner-Auswahl.
     */
    CompanyActionListUi.prototype.handleContactChange = function (e) {

        var el        = $(e.currentTarget);
        var contactId = el.val();
        var companyId = el.parents('.companyListContacts')
                .attr('data-company-id');

        if (!el.is(':checked')) {

            this.addContact(companyId, contactId, function (success) {
                if (!success) {
                    el.prop('checked', false);
                }
            });
        } else {
            this.removeContact(companyId, contactId, function (success) {
                if (!success) {
                    el.prop('checked', true);
                }
            });
        }
    };

    /**
     * Handler fuer das vollstaendige Laden einer Liste mit Ansprechpartnern.
     */
    CompanyActionListUi.prototype.handleContactsLoaded = function () {
        this.uncheckAllCheckboxes()
                .checkCheckboxes();
    };

    /**
     * Deselektiert alle Checkboxen, die fuer die Aktionslisten relevant sind
     * (Firmen und Ansprechpartner).
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.uncheckAllCheckboxes = function () {
        this.companyCheckboxes.iCheck('uncheck');
        $(this.contactCheckboxesSelector).iCheck('uncheck');

        return this;
    };

    /**
     * Markiert die Checkboxen der in den uebergebenen Daten enthaltenen Firmen und
     * Ansprechpartner.
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.checkCheckboxes = function () {

        var self = this;

        this.companyCheckboxes.each(function (idx, el) {

            var companyId = el.value;
            var isCompanyOnList;
            var contactsOnList;

            if (!self.companiesWithContacts.hasOwnProperty(companyId)) {
                return;
            }

            isCompanyOnList = self.companiesWithContacts[companyId].isCompanyOnList;
            contactsOnList  = self.companiesWithContacts[companyId].contactsOnList;

            if (isCompanyOnList) {
                $(el).iCheck('check');
            }

            contactsOnList.forEach(function (contactId) {
                $('.companyListContacts')
                        .filter('[data-company-id="' + companyId + '"]')
                        .find(self.contactCheckboxesSelector)
                        .filter('[value="' + contactId + '"]')
                        .iCheck('check');
            });
        });

        return this;
    };

    /**
     * Holt die Firmen-IDs und dazugehoerige Ansprechpartner fuer die gewaehlte
     * Aktionsliste.
     *
     * @param {Function} cb Callback, wird mit dem Ergebnis als erstem Parameter
     *                      aufgerufen
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.getCompaniesAndContacts = function (cb) {

        var companyIds = this.companyCheckboxes.map(function (idx, el) {
            return this.value;
        }).get().join();

        $.ajax({
            url: '/company/action-list/companies-with-contacts/' + this.actionList.val() + '/' + companyIds,
            method: 'GET',
            loadingOverlay: true
        }).done(function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            if (data.success) {
                cb(data.companiesWithContacts);
            } else {
                cb([]);
            }
        });

        return this;
    };

    /**
     * Eine Firma zur ausgewaehlten Aktionsliste hinzufuegen.
     *
     * @param {Number} companyId
     * @param {Function} cb Callback, wird mit Erfolgsstatus als Parameter
     *                      aufgerufen
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.addCompany = function (companyId, cb) {

        var self = this;

        $.post('/company/action-list/add-company/' + companyId, {
            listId: this.actionList.val()
        }, function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            cb(data.success);
            if (!self.companiesWithContacts.hasOwnProperty(companyId)) {
                self.companiesWithContacts[companyId] = {
                    isCompanyOnList: false,
                    contactsOnList: []
                };
            }
            self.companiesWithContacts[companyId].isCompanyOnList = true;
        });

        return this;
    };

    /**
     * Eine Firma von der ausgewaehlten Aktionsliste entfernen.
     *
     * @param {Number} companyId
     * @param {Function} cb Callback, wird mit Erfolgsstatus als Parameter
     *                      aufgerufen
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.removeCompany = function (companyId, cb) {

        var self = this;

        $.post('/company/action-list/remove-company/' + companyId, {
            listId: this.actionList.val()
        }, function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            cb(data.success);
            if (!self.companiesWithContacts.hasOwnProperty(companyId)) {
                self.companiesWithContacts[companyId] = {
                    isCompanyOnList: false,
                    contactsOnList: []
                };
            }
            self.companiesWithContacts[companyId].isCompanyOnList = false;
        });

        return this;
    };

    /**
     * Einen Ansprechpartner zur ausgewaehlten Aktionsliste hinzufuegen.
     *
     * @param {Number} companyId
     * @param {Number} contactId
     * @param {Function} cb Callback, wird mit Erfolgsstatus als Parameter
     *                      aufgerufen
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.addContact = function (companyId, contactId, cb) {
        var self = this;
        $.post('/company/action-list/add-contact/' + companyId, {
            listId: this.actionList.val(),
            contactId : contactId
        }, function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            cb(data.success);
            if (!self.companiesWithContacts.hasOwnProperty(companyId)) {
                self.companiesWithContacts[companyId] = {
                    isCompanyOnList: false,
                    contactsOnList: []
                };
            }
            self.companiesWithContacts[companyId].contactsOnList.push(contactId);
        });

        return this;
    };

    /**
     * Einen Ansprechpartner von der ausgewaehlten Aktionsliste entfernen.
     *
     * @param {Number} companyId
     * @param {Number} contactId
     * @param {Function} cb Callback, wird mit Erfolgsstatus als Parameter
     *                      aufgerufen
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.removeContact = function (companyId, contactId, cb) {
        var self = this;
        $.post('/company/action-list/remove-contact/' + companyId, {
            listId: this.actionList.val(),
            contactId : contactId
        }, function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            cb(data.success);
            if (self.companiesWithContacts.hasOwnProperty(companyId)) {
                var contacts = self.companiesWithContacts[companyId].contactsOnList;
                contacts.splice( $.inArray(contactId, contacts), 1 );
                self.companiesWithContacts[companyId].contactsOnList = contacts;
            }
        });

        return this;
    };

    /**
     * Alle gefundenen Firmen zur Aktionsliste hinzufuegen.
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.applyCompanies = function () {

        $.ajax({
            url: '/company/action-list/apply-all/' + this.actionList.val(),
            method: 'POST',
            loadingOverlay: true
        }).done($.proxy(function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            if (data.success) {
                var self = this;

                data.companyIds.forEach(function (id) {
                    if (!self.companiesWithContacts.hasOwnProperty(id)) {
                        self.companiesWithContacts[id] = {
                            isCompanyOnList: false,
                            contactsOnList: []
                        };
                    }
                    self.companiesWithContacts[id].isCompanyOnList = true;
                });

                this.checkCheckboxes();
            }
        }, this));

        return this;
    };

    CompanyActionListUi.prototype.applyContacts = function () {
        var self = this;

        $.post('/company/action-list/apply-all-contacts/' + this.actionList.val(),
            $.proxy(function (data) {
                var blockLoader = new Esearcher.BlockLoader();
                blockLoader.process(data);
                if (data.success) {
                    $(this.contactCheckboxesSelector).each(function(index) {
                        $(this).iCheck('check');
                    });
                }
            }, this));

        return this;
    };

    /**
     * Leert die ausgewaehlte Aktionsliste von allen Firmen und Ansprechpartnern.
     *
     * @returns {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.emptyList = function () {

        $.ajax({
            url: '/company/action-list/empty-all/' + this.actionList.val(),
            method: 'POST',
            loadingOverlay: true
        }).done($.proxy(function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            if (data.success) {
                this.companiesWithContacts = {};
                this.uncheckAllCheckboxes();
            }
        }, this));

        return this;
    };

    /**
     * Gibt zurueck, ob eine Aktionsliste ausgewaehlt wurde.
     *
     * @returns {Boolean}
     */
    CompanyActionListUi.prototype.hasListSelected = function () {
        return this.actionList.val() !== '0';
    };

    /**
     * Zeigt die Checkboxen vor den Firmen und Ansprechpartnern an.
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.showCheckboxes = function () {
        this.companyCheckboxes.each(function(i, e) {
            $(e).removeClass('no-ready');
            $(e).parent().show();
            $(e).parent().parent().show();
        });
        $(this.contactCheckboxesSelector).each(function(i, e) {
            $(e).removeClass('no-ready');
            $(e).parent().show();
            $(e).parent().parent().show();
        });

        parseCheckboxes();
        return this;
    };

    /**
     * Versteckt die Checkboxen vor Firmen und Ansprechpartnern.
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.hideCheckboxes = function () {
        this.companyCheckboxes.each(function(i, e) {
            $(e).addClass('no-ready');
            if ($(e).parent().hasClass('checkbox-square')) {
                $(e).parent().hide();
            }
        });
        $(this.contactCheckboxesSelector).each(function(i, e) {
            $(e).addClass('no-ready');
            $(e).parent().hide();
        });

        parseCheckboxes();
        return this;
    };

    var companyActionList = new CompanyActionListUi();

    companyActionList.initHandlers();
});

Esearcher.page('jobListing', function () {

    $('.jobListShowPopupButton').on('click', function (e) {
        e.preventDefault();

        var pop = new Esearcher.Popup(this.getAttribute('href'), 'Aktion');

        pop.show();
    });
});

Esearcher.page('company', function() {

    var currentTab = 'company';
    var currentContactId;

    this.on('tabFinish', function(e) {
        currentTab = e.tab;
    });

    $(document).on('click', '.createContactButton', function() {

        var form = new Esearcher.Helper.Form('contactForm');

        form.reset('companyPersonId', 'anrede', 'titel', 'vorname', 'nachname',
                'abteilung', 'funktion', 'geburtstag', 'telefon', 'skype',
                'mobil', 'icq', 'msn', 'telefax', 'aim', 'email', 'yahoo',
                'privateHP', 'klassifikation[1]', 'klassifikation[2]',
                'klassifikation[3]', 'klassifikation[4]', 'notizen');

        // nur fuer bereits existente Benutzer sinnvoll
        $('#contactEmail').remove();

        $('#blockContactPersonPicture .picture').html('');
    });

    $(document).on('click', '.changeContactPicBtn', function() {

       $('.blockPictureDialog').dialog({
            title: $('.changeContactPicBtn').val(),
            resizable: false,
            modal: true,
            buttons: [
                {
                class: 'modal-icon closeIcon',
                position: '.modal-buttons',
                'click': function () {
                    $(this).dialog('close');
                }
                }
            ]
       });
        $('div.modal-dialog').addClass('modal-sm ');
    });

    function generateWriteStdDocUrl(documentId, companyId, personId, companyPersonId) {
        return '/write_stddok.php?did=' + documentId
                + '&fid=' + companyId
                + '&pid=' + personId
                + '&fpid=' + companyPersonId;
    }

    $(document).on('change', '.companyContactWriteDocument', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var dataElement = $(e.currentTarget).find(":selected");

        var target = '/write_stddok.php?did=' + dataElement.data('actionId') +
            '&fid=' + $('#dataId').val() +
            '&pid=' + dataElement.data('contactId') +
            '&fpid=' + dataElement.data('companyContactId');

        if (dataElement.data('actionType') === 'draft') {
            target = '/write_stddok.php?draftid=' + dataElement.data('actionId');
        }

        Esearcher.Helper.navigation.redirect(dataElement.data('backUrl'), target);
    });

    $(document).on('click', '.companyWriteEmailToContactButton', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var dataElement = $(e.currentTarget).find(":selected");
        var writeUri = generateWriteStdDocUrl(
            $(this).attr('data-action-id'),
            $('#dataId').val(),
            $(this).attr('data-contact-id'),
            $(this).attr('data-company-contact-id')
        );

        Esearcher.Helper.navigation.redirect($(this).attr('data-back-url'),
            writeUri);
    });


});

Esearcher.page('applicant', function () {

    var currentProfile = Esearcher.Helper.url.getParameterValue('profileId');
    var highlightTabsForProfile = function (doHighlight) {

        var method = doHighlight ? 'addClass' : 'removeClass';

        $('a[href="#job"], a[href="#cv"], a[href="#internalProfile"], a[href="#skills"]')
                .parent()[method]('editingNonDefaultProfile');
    };

    $(document).on('click', '#changeApplicantPicBtn', function() {
        $('.blockPictureDialog').dialog({
            title: $('#changeApplicantPicBtn').val(),
            modal: true,
            width: 'auto',

            buttons: [{
            html: "Schlie&szlig;en",
            click: function() {
                    $(this).dialog('close');
                }
            }]
       });
    });

    $(document).on('click', '#profileLink', function () {

        var profileType = $('#profilTypId').val();
        var profileId = $('#profilId').val();

        window.open('/applicant/profile/' +
                profileType + '/' + profileId, '_blank');
    });

    $(document).on('change', '.applicantWriteDocument', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var dataElement = $(e.currentTarget).find(":selected");
        var target = '/write_stddok.php?did=' + dataElement.data('actionId') + '&kid=' + $('#dataId').val();

        if (dataElement.data('actionType') === 'draft') {
            target = '/write_stddok.php?draftid=' + dataElement.data('actionId');
        }

        Esearcher.Helper.navigation.redirect(dataElement.data('backUrl'), target);
    });

    $(document).on('click', '#newCvEntryButton', function() {

        var form = new Esearcher.Helper.Form('cvForm');

        form.reset('editId', 'kind', 'placeWhere', 'positionDegree',
                'periodMonthBegin', 'periodMonthEnd', 'periodYearBegin',
                'periodYearEnd', 'industry', 'description')
            .get('kind').trigger('focus');
    });

    $(document).on('click', '.sortCvChronologically', function() {
        crm.showTabOverlay();

        var userId = $('#dataId').val();
        var profileId = $('#cvFormProfileId').val();

        if(profileId === undefined){
            profileId = 0;
        }

        $.post("/applicant/tab/cv/table/sortable/save-cv-chronologically/" + userId + "/" + profileId)
            .done(function(data) {
                if(data.table){
                    const tableSortable = $(data.table).find('#tableSortable');
                    $("#tableSortable").replaceWith(tableSortable);

                    if (tableSortable.length){
                        new SortableTable(tableSortable);
                    }
                }
                crm.hideTabOverlay();
            });
    });

    // "Kandidatenprofile mergen"-Popup
    $(document).on('click', '.applicantMergeInternalProfileButton', function(e) {
            var me = $(this);

            var dialog = $('<iframe id="externalSite" class="externalSite" ' +
                'border="0" style="border:0px;" src="' + me.attr('data-merge-url') + '" />');
            dialog.dialog({
                title: me.attr('title') ? me.attr('title') : 'External Site',
                width: 1000,
                height: 600,
                modal: true,
                buttons: [{
                    class: 'modal-icon closeIcon',
                    position: '.modal-buttons',
                    'click': function () {
                        dialog.dialog('destroy');
                    }
                }]
            });
    });

    if (currentProfile) {
        highlightTabsForProfile(true);
    }

    /**
     * If the documents type changes in the documents form, then the correct allowed file types are set for the file uploader.
     */
    $(document).on('change', '#documentsForm #documentsFormDocumentType', function() {
        var documentsForm = $('#documentsForm');
        var docType = documentsForm.find('#documentsFormDocumentType').val();
        var applicantId = $('#dataId').val();
        var fileUploaderId = documentsForm.find('.fileuploaderId').val();

        $.ajax({
            type: "POST",
            url: '/applicant/tab/document/change-doctype/' + applicantId + '/' + docType + '/?fileuploaderId=' + fileUploaderId,
            loadingOverlay: true
        }).done(function (data) {
            // Replace the html with the new allowed file types string.
            documentsForm.find('.allowedFileTypes').html(data.allowedFileTypes);

            // We have to remove all uploaded files after changing the file type, because it could be that one of the already uploaded files is part of the new not allowed file types.
            documentsForm.find('.deleteFile').each(function() {
                var defaultFileUploaderWidget = widget.getById(documentsForm.find('[widget="esearcher.fileuploader_defaultFileuploader"]').attr('widgetid'));
                defaultFileUploaderWidget.deleteFile($(this));
            });
        });
    });
});

Esearcher.page('company', function () {

    $(document).on('click', '.searchParentCompanyButton', function () {
        var url = '/popup_mutter_search.php?fid=' + $('#dataId').val();

        var p = new Esearcher.Popup(url, 'Muttersuche');
        p.show();
    });

    $(document).on('change', '.visitCountryInfo', function () {

        var link = $('.visitCountryInfoButton');

        var countryStr = $(this).find('option:selected').text()
                .replace(/ä/g, 'ae')
                .replace(/ö/g, 'oe')
                .replace(/ü/g, 'ue')
                .replace(/Ä/g, 'Ae')
                .replace(/Ö/g, 'Oe')
                .replace(/Ü/g, 'Ue')
                .replace(/ß/g, 'ss');

        var url = Esearcher.Template.parse(link.attr('data-url-template'), {
            country: countryStr
        });

        link.attr('href', url);
    });
});

Esearcher.page('applicant', function() {

    $(document).on('click', '#showDateInfo', function() {
        $('#dateinfo').toggle();
    });
});

/*global window jQuery document hrglob*/
/*jslint evil: true */
var no_loader = 0;


//--------------------------------------------------------
// hrglob
(function(window, $) {
    // is only used inside, you should never publish this, instead use jquerys inarray
    function inArray(arr, val) {
        var i;
        for (i = 0; i < arr.length; ++i) {
            if (arr[i] === val) {
                return true;
            }
        }
        return false;
    }


    function jsonAddAndEval(str1, str2) {
        var obj1 = '';
        var obj2 = '';

        if (typeof str1 === 'object') {
            obj1 = str1;
        } else {
            obj1 = eval('(' + str1 + ')');
        }

        if (typeof str2 === 'object') {
            obj2 = str1;
        } else {
            obj2 = eval('(' + str2 + ')');
        }

        jQuery.extend(true, obj1, obj2);

        return obj1;
    }





    var hrglob = {
        version: '1.0',
        fillSelectKwByJahrMonat: function(yearId, monthId, kwId, createAllEntry) {
            var year = jQuery('#' + yearId);
            var month = jQuery('#' + monthId);
            var target = jQuery('#' + kwId);

            target.html('');

            var entrys = [];
            var i;
            for (i = 1; i <= 31; ++i) {
                var akw = hrglob.getKw(year.val(), month.val(), i);

                if (inArray(entrys, akw) === false) {
                    entrys.push(akw);
                }
            }

            var newHtml = '';
            if (typeof createAllEntry !== 'undefined') {
                newHtml = newHtml + '<option value"' + createAllEntry + '">- alle -</option>';
            }

            jQuery.each(entrys, function(key, val) {
                newHtml = newHtml + '<option value="' + val + '">' + val + '</option>';
            });

            target.html(newHtml);
        },
        checkGerDate: function(datum) {
            if (!datum) {
                return false;
            }
            datum = datum.toString();

            datum = datum.split(".");
            if (datum.length !== 3) {
                return false;
            }

            datum[0] = parseInt(datum[0], 10);
            datum[1] = parseInt(datum[1], 10) - 1;

            if (datum[2].length === 2) {
                datum[2] = "20" + datum[2];
            }

            datum[0] = parseInt(datum[0], 10);
            datum[1] = parseInt(datum[1], 10);
            datum[2] = parseInt(datum[2], 10);

            var kontrolldatum = new Date(datum[2], datum[1], datum[0]);

            if (kontrolldatum.getDate() === datum[0] && kontrolldatum.getMonth() === datum[1] && kontrolldatum.getFullYear() === datum[2]) {
                return true;
            }
            else {
                return false;
            }
        },
        attachRestOfDate: function() {
            var txt = jQuery(this).val();
            if (txt) {
                var mytime = new Date();
                var monat = mytime.getMonth() + 1;
                var jahr = mytime.getFullYear();
                var tag = mytime.getDate();

                txt = txt.replace(',', '.').replace('-', '.').replace('/', '.').replace(';', '.').replace(':', '.');
                var arr = txt.split('.');

                if (!arr[2]) {
                    arr[2] = jahr + '';
                }
                if (!arr[1]) {
                    arr[1] = monat + '';
                }
                if (!arr[0]) {
                    arr[0] = tag + '';
                }

                if (arr[0].length === 1) {
                    arr[0] = '0' + arr[0];
                }
                if (arr[1].length === 1) {
                    arr[1] = '0' + arr[1];
                }

                txt = arr[0] + '.' + arr[1] + '.' + arr[2];
                if (hrglob.checkGerDate(txt) === false) {
                    txt = '';
                }
                jQuery(this).val(txt);
            }
        },
        attachRestOfHour: function() {
            var txt = jQuery(this).val();
            if (txt) {
                var error = 0;
                txt = txt.replace(',', ':').replace('-', ':').replace('/', ':').replace(';', ':').replace('.', ':');
                var arr = txt.split(':');

                if ((arr[0].length === 4 || arr[0].length === 3) && arr[1] === undefined) {
                    arr[1] = arr[0].substr(2);
                    arr[0] = arr[0].substr(0, 2);
                }

                if (arr[1] !== undefined && arr[1].length === 1) {
                    arr[1] = arr[1] + '0';
                }



                if (!arr[1]) {
                    arr[1] = '00';
                }
                if (arr[3] !== undefined) {
                    error = 1;
                }

                arr[0] = parseInt(arr[0], 10);
                arr[1] = parseInt(arr[1], 10);

                if (isNaN(arr[0]) || isNaN(arr[1])) {
                    error = 1;
                }

                if (arr[0] === 0 && arr[1] === 0) {
                    arr[0] = 24;
                }

                if (arr[0] !== 24 || arr[1] !== 0) {
                    if (arr[0] < 0 || arr[0] > 23) {
                        error = 1;
                    }
                    if (arr[1] < 0 || arr[1] > 59) {
                        error = 1;
                    }
                }


                if (error === 0) {
                    arr[0] = String(arr[0]);
                    arr[1] = String(arr[1]);
                    if (arr[0].length === 1) {
                        arr[0] = '0' + arr[0];
                    }
                    if (arr[1].length === 1) {
                        arr[1] = '0' + arr[1];
                    }
                    txt = arr[0] + ':' + arr[1];
                } else {
                    txt = '';
                }


                jQuery(this).val(txt);
            }
        },
        checkNumber: function() {
            hrglob.checkNumberReadTitle(this);
            var txt = jQuery(this).val();
            if (txt) {
                txt = txt.replace(',', '.').replace('/', '.').replace(';', '.').replace(':', '.');

                var txt2 = parseFloat(txt);
                if (isNaN(txt2) || txt2 < jQuery.data(this, 'min') || txt2 > jQuery.data(this, 'max')) {
                    txt = '';
                }

                jQuery(this).val(txt);
            }
        },
        checkNumberReadTitle: function(obj) {
            if (!jQuery.data(obj, 'min') || !jQuery.data(obj, 'max')) {
                var min = -99999999;
                var max = 99999999;
                if (jQuery(obj).attr('title')) {
                    var min_match,
                            max_match,
                            title = jQuery(obj).attr('title');
                    min_match = title.match(/min=[\-\d.\d]*/);

                    if (min_match && min_match[0]) {
                        min_match[0].split('=')[1];
                    }

                    max_match = title.match(/max=[\-\d.\d]*/);

                    if (max_match && max_match[0]) {
                        max_match[0].split('=')[1];
                    }
                }
                jQuery.data(obj, 'min', min);
                jQuery.data(obj, 'max', max);
            }
        },
        // you should never use this function, please well format your json,
        // this function is depracated and will be removed, when its time
        processEval: function(str) {
            str = str.replace("}{", "}|split|{");
            str = str.split("|split|");

            var i;
            for (i = 0; i < str.length; ++i) {
                str[0] = jsonAddAndEval(str[0], str[i]);
            }

            return str[0];
        },
        addMonthTodate: function(datum, monate, trim_ende) {
            var d = datum.getDate();
            var m = datum.getMonth() + 1;
            var y = datum.getFullYear();


            m = m + monate;

            if (m > 12)
            {
                y = y + 1;
                m = m - 12;
            }

            datum.setDate(d);
            datum.setMonth(m - 1);
            datum.setFullYear(y);


            if (trim_ende === true)
            {
                if ((datum.getMonth() + 1) > m)
                {
                    d = hrglob.getLastDayOfMonth(y, m - 1);
                    datum.setDate(d);
                    datum.setMonth(m - 1);
                }
            }
        },
        getJsdateFromGerdate: function(datum) {
            if (!datum) {
                return false;
            }
            datum = datum.toString();

            datum = datum.split(".");
            if (datum.length !== 3) {
                return false;
            }

            datum[0] = parseInt(datum[0], 10);
            datum[1] = parseInt(datum[1], 10) - 1;

            if (datum[2].length === 2) {
                datum[2] = "20" + datum[2];
            }
            var kontrolldatum = new Date(datum[2], datum[1], datum[0]);

            return kontrolldatum;
        },
        getGerdateFromJsdate: function(datum) {
            var d = String(datum.getDate());
            if (d.length === 1) {
                d = '0' + d;
            }

            var m = parseInt(datum.getMonth(), 10);
            m = m + 1;
            m = String(m);
            if (m.length === 1) {
                m = '0' + m;
            }
            var y = datum.getFullYear();

            return d + '.' + m + '.' + y;
        },
        getLastDayOfMonth: function(Year, Month) {
            return(new Date((new Date(Year, Month + 1, 1)) - 1)).getDate();
        },
        resetFormById: function(id) {
            jQuery('#' + id).each(function() {
                this.reset();
            });
        },
        emulateOldTabs: function(tabid, pk) {
            var seltab = jQuery('#' + tabid).tabs('option', 'active');
            var formIdToSubmit = '';
            jQuery('#' + tabid + ' > div').each(function(index, obj) {
                var form = jQuery('#' + obj.id + ' form').attr('id');
                if (seltab === index) {
                    formIdToSubmit = form;
                } else {
                    hrglob.resetFormById(form);
                }
            });

            //var tabcnt = jQuery('#'+tabid).tabs( 'length' );
            var tabcnt = $('#' + tabid + ' >ul >li').size();
            var mode = 'enable';

            if (!pk && pk !== 0) {
                mode = 'disable';
            }

            var i;
            for (i = 1; i <= tabcnt; i++) {
                jQuery('#' + tabid).tabs(mode, i - 1);
            }

            return formIdToSubmit;
        },
        getKw: function(j, m, t) {
            var Datum = new Date();
            if (!t) {
                j = Datum.getYear();
                if (1900 > j) {
                    j += 1900;
                }
                m = Datum.getMonth();
                t = Datum.getDate();
            }
            else {
                m = m - 1;
            }

            Datum = new Date(j, m, t, 0, 0, 1);
            var tag = Datum.getDay();
            if (tag === 0) {
                tag = 7;
            }
            var d = new Date(2004, 0, 1).getTimezoneOffset();
            var Sommerzeit = (Date.UTC(j, m, t, 0, d, 1) - Number(Datum)) / 3600000;
            Datum.setTime(Number(Datum) + Sommerzeit * 3600000 - (tag - 1) * 86400000);
            var Jahr = Datum.getYear();

            if (1900 > Jahr) {
                Jahr += 1900;
            }

            var kw = 1;
            if (new Date(Jahr, 11, 29) > Datum) {
                var Start = new Date(Jahr, 0, 1);
                Start = new Date(Number(Start) + 86400000 * (8 - Start.getDay()));

                if (Start.getDate() > 4) {
                    Start.setTime(Number(Start) - 604800000);
                }
                kw = Math.ceil((Datum.getTime() - Start) / 604800000);
            }
            return kw;
        },
        datepicker_options: {
            showOn: 'button',
            buttonImage: 'images/icon_calendar_pop.gif',
            buttonImageOnly: true,
            showAnim: 'slideDown',
            dateFormat: 'dd.mm.yy'
        },
        loadDatepickers: function() {
            jQuery("input.datum").datepicker(hrglob.datepicker_options);
        }



    };

    // Expose hrglob to the global object
    return (window.hrglob = hrglob);
}(window, jQuery));
// hrglob
//--------------------------------------------------------



//--------------------------------------------------------
// jQuery extensions: serializeAll und serializeArrayAll
(function($) {
    $.fn.extend({
        serializeAll: function() {
            return jQuery.param(this.serializeArrayAll());
        },
        serializeArrayAll: function() {
            return this.map(function() {
                return this.elements ? jQuery.makeArray(this.elements) : this;
            })
                    .filter(function() {
                        return this.name && (this.checked || /select|textarea/i.test(this.nodeName) || /color|date|datetime|email|hidden|month|number|password|range|search|tel|text|time|url|week/i.test(this.type));
                    })
                    .map(function(i, elem) {
                        var val = jQuery(this).val();

                        return val === null ?
                                null :
                                jQuery.isArray(val) ?
                                jQuery.map(val, function(val, i) {
                                    return {name: elem.name, value: val};
                                }) :
                                {name: elem.name, value: val};
                    }).get();
        }
    });
}(jQuery));
//jQuery extensions: serializeAll und serializeArrayAll
//--------------------------------------------------------




// -------------------------------------------------------
//blur+focus bei jQuery.live()
(function($) {

    var uid1 = 'D' + (+new Date()),
            uid2 = 'D' + (+new Date() + 1);

    jQuery.event.special.focus = {
        setup: function() {
            var _self = this,
                    handler = function(e) {
                        e = jQuery.event.fix(e);
                        e.type = 'focus';
                        if (_self === document && typeof(jQuery.event.handle) !== 'undefined') {
                            jQuery.event.handle.call(_self, e);
                        }
                    };

            jQuery(this).data(uid1, handler);

            if (_self === document) {
                /* Must be live() */
                if (_self.addEventListener) {
                    _self.addEventListener('focus', handler, true);
                } else {
                    _self.attachEvent('onfocusin', handler);
                }
            } else {
                return false;
            }

        },
        teardown: function() {
            var handler = jQuery(this).data(uid1);
            if (this === document) {
                if (this.removeEventListener) {
                    this.removeEventListener('focus', handler, true);
                } else {
                    this.detachEvent('onfocusin', handler);
                }
            }
        }
    };

    jQuery.event.special.blur = {
        setup: function() {
            var _self = this,
                    handler = function(e) {
                        e = jQuery.event.fix(e);
                        e.type = 'blur';
                        if (_self === document && typeof(jQuery.event.handle) !== 'undefined') {
                            jQuery.event.handle.call(_self, e);
                        }
                    };

            jQuery(this).data(uid2, handler);

            if (_self === document) {
                /* Must be live() */
                if (_self.addEventListener) {
                    _self.addEventListener('blur', handler, true);
                } else {
                    _self.attachEvent('onfocusout', handler);
                }
            } else {
                return false;
            }

        },
        teardown: function() {
            var handler = jQuery(this).data(uid2);
            if (this === document) {
                if (this.removeEventListener) {
                    this.removeEventListener('blur', handler, true);
                } else {
                    this.detachEvent('onfocusout', handler);
                }
            }
        }
    };
}(jQuery));
//blur+focus bei jQuery.live()
//-------------------------------------------------------


//-------------------------------------------------------
// bind event handlers
jQuery(function() {
    // loader
    jQuery(document).ajaxStart(function() {
        if (no_loader === 0) {
            jQuery('.loading').show();
        }
    });

    jQuery(document).ajaxStop(function() {
        jQuery('.loading').hide();
    });

    jQuery(".nummer").on('keydown', function(e) {
        if (e.keyCode === 32) { // leertaste
            e.preventDefault();
        }
        hrglob.checkNumberReadTitle(this);

        if (e.keyCode === 188 || e.keyCode === 190 || e.keyCode === 110) {
            var myval = jQuery(this).val();

            if (myval.search(/\./) === -1) {
                jQuery(this).val(myval + '.');
            }
            e.preventDefault();
        }
    });

    jQuery("input.nummer").on('blur', hrglob.checkNumber);
    jQuery("input.stunde").on('blur', hrglob.attachRestOfHour);
    jQuery("input.datum").on('blur', hrglob.attachRestOfDate);
    hrglob.loadDatepickers();
});
//bind event handlers
//-------------------------------------------------------


/*global jQuery crm:false*/
var unternehmen = (function($) {

    var did = parseInt($('#dok_id').val(), 10);

    return {
        createDokument: function(fid) {
            $('#write_doc').click(function(e) {
                e.preventDefault();
                $.ajax({
                    type: "GET",
                    url: crm.ajaxRequestUri + 'company/' + fid,
                    data: "ajax_action=receive&ajax_format=json&ajax_requestname=" +
                            'createDokument' + '&tab=unternehmen&fid=' + fid +
                            "&fdok_id=" + did,
                    success: function(data) {
                        location.href = data;
                    }
                });
            });
        }
    };
}(jQuery));

Esearcher.page('company', function() {

//    $(document).on('loadFinish', function() {
//        (new MessageFader('.tabMessages li').process($('.tabBtnSave')));
//    });

    $(document).on('change', '.companyWriteDocument', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var dataElement = $(e.currentTarget).find(":selected");
        var target = '/write_stddok.php?did=' + dataElement.data('actionId') + '&fid=' + $('#dataId').val();

        if (dataElement.data('actionType') === 'draft') {
            target = '/write_stddok.php?draftid=' + dataElement.data('actionId');
        }

        Esearcher.Helper.navigation.redirect(dataElement.data('backUrl'), target);
    });

    $(document).on('click', '.companyWriteEmailButton', function (e) {
        e.preventDefault();
        e.stopPropagation();
        Esearcher.Helper.navigation.redirect($(e.currentTarget).data('backUrl'),
                '/write_stddok.php?did=0&fid=' + $('#dataId').val());
    });

    $(document).on('click', '.companyRemoveAssignmentButton', function () {
        $('#companyFormMotherCompanyId').val(0);
        $('#companyFormMotherCompanyStr').val('');
    });
});

//# sourceMappingURL=maps/build.js.map
